// Auto-generated products catalog with interactive galleries, specs, base pricing, and bilingual i18n support (ES/EN)
export const PRODUCTS_CATALOG = [
  {
    "id": "grabado-copas",
    "name": "Grabado de copas",
    "title": "Grabado de copas",
    "nameEn": "Wine Glass Engraving",
    "titleEn": "Wine Glass Engraving",
    "reference": "ESP-001",
    "category": "Copas y Cristal",
    "categoryEn": "Glassware & Glasses",
    "description": "Grabado ultrafino sobre cualquier tipo de copa (Burdeos, Borgoña, Flauta o Catavinos). Inalterable en túneles de lavado.",
    "extendedDescription": "Personalización exclusiva en copas de cristal fino mediante tecnología de grabado láser UV en frío (355nm). Realiza un marcado fotoquímico sin astillado ni microfracturas térmicas, dejando un acabado satinado blanco esmerilado suave al tacto que destaca contra el color del vino. Apto al 100% para lavavajillas industriales en bodegas, catas y eventos de alta restauración. Grabamos sobre tu propio stock o suministramos cristalería completa.",
    "specs": [
      "Grabado en exterior del cáliz, base o fuste",
      "100% apto para lavavajillas industrial",
      "Líneas de aforo para servicio de catas",
      "Grabamos tu propio stock o te suministramos",
      "Tecnología láser UV frío 355nm (cero astillado)"
    ],
    "image": "/catalog/grabado-copas.jpg",
    "images": [
      "/catalog/grabado-copas.jpg",
      "/catalog/decantador-pikerson_1.jpg",
      "/catalog/set-vino-gargant_1.jpg"
    ],
    "basePrice": 2.66,
    "unit": "unidades",
    "minQuantity": 24,
    "maxQuantity": 10000,
    "quantityStep": 24,
    "defaultQuantity": 100,
    "active": true,
    "isApproximatePrice": true,
    "priceNote": "Precio aproximado",
    "priceNoteEn": "Approximate price",
    "priceNoteDetail": "Precio aproximado según modelo de copa y tirada. Tarifa orientativa desde 2,66 €/ud aplicando el 5% de descuento por volumen a partir de 100 unidades.",
    "priceNoteDetailEn": "Approximate price depending on glass model and volume. Indicative rate from €2.66/unit with 5% volume discount starting from 100 units.",
    "descriptionEn": "Ultra-fine UV laser engraving on all types of fine crystal glassware (Bordeaux, Burgundy, Flute, or Tasting). 100% commercial dishwasher safe.",
    "extendedDescriptionEn": "Exclusive customization on fine crystal glassware using cold 355nm UV laser technology. Photochemical marking with zero thermal microfractures, delivering an elegant frosted satin finish. We engrave your existing stock or supply complete glassware with tasting fill lines and winery logos.",
    "specsEn": [
      "Engraving on bowl exterior, base, or stem",
      "100% commercial dishwasher safe",
      "Tasting fill lines for sommelier service",
      "We engrave your own stock or supply glassware",
      "Cold 355nm UV laser technology (zero chipping)"
    ]
  },
  {
    "id": "grabado-tapones",
    "name": "Grabado de tapones",
    "title": "Grabado de tapones",
    "nameEn": "Cork Stopper Engraving",
    "titleEn": "Cork Stopper Engraving",
    "reference": "ESP-002",
    "category": "Accesorios de Sumiller",
    "categoryEn": "Sommelier Accessories",
    "description": "Personalización en tapones de corcho natural, cabezales sintéticos y estuches de presentación enológica.",
    "extendedDescription": "Marcado láser UV de alta definición en negro carbón sobre corcho natural, cabezal sintético o madera. Permite plasmar el emblema de la bodega, añada, escudo o código de trazabilidad tanto en el lateral como en la cabeza del corcho. Proceso en seco sin tintas ni adhesivos químicos, respetando la pureza organoléptica del vino y el embotellado de alta gama.",
    "specs": [
      "Grabado en negro carbón de alta definición",
      "Marcado en lateral o cabeza del corcho",
      "Cajas y estuches de madera de pino grabados",
      "Sin pedido mínimo abusivo (desde 50 unidades)",
      "Proceso 100% libre de tintas químicas y solventes"
    ],
    "image": "/catalog/grabado-tapones.jpg",
    "images": [
      "/catalog/grabado-tapones.jpg",
      "/catalog/set-vino-gargant_1.jpg",
      "/catalog/estuche-vino-px-con-abridor-sacacorchos_1.jpg"
    ],
    "basePrice": 0.81,
    "unit": "unidades",
    "minQuantity": 50,
    "maxQuantity": 25000,
    "quantityStep": 50,
    "defaultQuantity": 250,
    "active": true,
    "isApproximatePrice": true,
    "priceNote": "Precio aproximado",
    "priceNoteEn": "Approximate price",
    "priceNoteDetail": "Precio aproximado según tipo de corcho (natural, colmatado o sintético) y volumen. Tarifa orientativa desde 0,81 €/ud aplicando el 5% de descuento por volumen a partir de 100 unidades.",
    "priceNoteDetailEn": "Approximate price depending on cork type and batch size. Indicative rate from €0.81/unit with 5% volume discount starting from 100 units.",
    "descriptionEn": "Custom engraving on natural cork stoppers, synthetic capsules, and wine presentation cases with high-definition micro-marking.",
    "extendedDescriptionEn": "High-definition carbon-black UV laser marking on natural cork, synthetic caps, or wood. Perfect for winery emblems, vintage years, crests, or traceability codes on both lateral sides and heads. Completely ink-free dry process preserving wine organoleptic purity.",
    "specsEn": [
      "High-definition carbon black engraving",
      "Marking on lateral flank or top head",
      "Pine wood boxes and engraved presentation cases",
      "Flexible minimum order quantities (from 50 units)",
      "100% ink and chemical solvent-free process"
    ]
  },
  {
    "id": "grabado-decantadores-vino",
    "name": "Grabado de Decantadores de vino",
    "title": "Grabado de Decantadores de vino",
    "nameEn": "Wine Decanter Engraving",
    "titleEn": "Wine Decanter Engraving",
    "reference": "ESP-003",
    "category": "Decantadores",
    "categoryEn": "Decanters",
    "description": "Grabado de precisión sobre decantadores y jarras de cristal para regalo corporativo, ediciones limitadas y mesa de bodega.",
    "extendedDescription": "Personalización artesanal de alta gama en decantadores de cristal soplado y jarras de oxigenación. El haz ultravioleta de 355nm marca delicadamente la curvatura del cuerpo o la base sin generar tensiones térmicas ni comprometer la resistencia estructural del cristal. Ideal para conmemoraciones, cosechas especiales de autor y regalos institucionales VIP.",
    "specs": [
      "Grabado esmerilado en cuerpo o base",
      "Ideal para regalo de empresa y VIP",
      "Ediciones numeradas y conmemorativas",
      "Precio aproximado a medida según modelo y tirada",
      "Apto para decantadores tradicionales, cisne o jarras"
    ],
    "image": "/catalog/grabado-decantadores.jpg",
    "images": [
      "/catalog/grabado-decantadores.jpg",
      "/catalog/decantador-pikerson_1.jpg",
      "/catalog/decantador-seirten_1.jpg"
    ],
    "basePrice": 12.5,
    "unit": "unidades",
    "minQuantity": 5,
    "maxQuantity": 1000,
    "quantityStep": 5,
    "defaultQuantity": 20,
    "active": true,
    "isApproximatePrice": true,
    "priceNote": "Precio aproximado",
    "priceNoteEn": "Approximate price",
    "priceNoteDetail": "Precio aproximado según modelo, capacidad y formato de decantador o jarra de vino (presupuesto a medida según tirada).",
    "priceNoteDetailEn": "Approximate price depending on decanter model, capacity, and design (custom quote available).",
    "descriptionEn": "Precision UV laser engraving on crystal decanters and carafes for corporate gifts, limited editions, and winery service.",
    "extendedDescriptionEn": "High-end bespoke customization on mouth-blown crystal decanters and aeration carafes. The 355nm UV laser beam delicately etches the curved surface or base without thermal stress. Ideal for anniversaries, reserve vintages, and VIP corporate gifts.",
    "specsEn": [
      "Frosted engraving on body curve or base",
      "Ideal for corporate and VIP executive gifting",
      "Numbered commemorative series available",
      "Approximate pricing tailored to model and run size",
      "Compatible with standard, swan or aerating carafes"
    ]
  },
  {
    "id": "aireador-vino-crianz",
    "name": "Aireador Vino Crianz",
    "reference": "MK-001",
    "category": "Aireadores",
    "description": "Aireador para vino con cuerpo en material acrílico de acabado transparente y ajuste de seguridad.",
    "extendedDescription": "El Aireador Vino Crianz oxigena el vino al instante mientras lo sirves directamente en la copa. Aireador para vino con cuerpo en material acrílico de acabado transparente y ajuste de seguridad.. Permite que el vino libere todo su aroma y sabor desde el primer sorbo, evitando cualquier goteo inoportuno. Un accesorio de sumiller que personalizamos mediante grabado laser para bodegas, catas privadas o regalos de empresa de gran categoria.",
    "specs": [
      "¿Sabías que un buen vino necesita respirar para mostrar su verdadera personalidad? 🍷",
      "Personalización exclusiva:",
      "Eleva tus momentos de cata al maximo nivel. ¡Pide el tuyo hoy!"
    ],
    "image": "/catalog/aireador-vino-crianz_1.jpg",
    "images": [
      "/catalog/aireador-vino-crianz_1.jpg",
      "/catalog/aireador-vino-crianz_2.jpg",
      "/catalog/aireador-vino-crianz_3.png",
      "/catalog/aireador-vino-crianz_4.png"
    ],
    "basePrice": 2.6,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Aireador Vino Crianz",
    "titleEn": "Crianz Wine Aerator",
    "nameEn": "Crianz Wine Aerator",
    "categoryEn": "Aerators",
    "descriptionEn": "Instant wine aerator crafted in transparent acrylic with leak-proof safety seal.",
    "extendedDescriptionEn": "The Crianz Wine Aerator instantly oxygenates wine as it is poured directly into the glass. Crafted with high-grade clear acrylic and a secure fit, it unlocks full bouquet and flavor from the very first pour while preventing drips. Perfect for custom UV laser engraving for wineries, VIP tastings, and executive corporate gifts.",
    "specsEn": [
      "Transparent food-grade acrylic",
      "Instant oxygenation chamber",
      "Drip-free silicone seal",
      "Custom UV laser engraved logo"
    ]
  },
  {
    "id": "baston-led-pexel",
    "name": "Bastón Led Pexel",
    "reference": "MK-002",
    "category": "Accesorios de Sumiller",
    "description": "Bastón LED con 3 modos de luz: alta intensidad, media intensidad y luz intermitente. Equipado con 36 LEDs y botón de encendido/apagado. Su tamaño es ideal para acoplar en botellas, destacando en cualquier evento.",
    "extendedDescription": "El Bastón Led Pexel está diseñado para acoplarse al cuello de tus botellas y crear un espectaculo de luz único. Bastón LED con 3 modos de luz: alta intensidad, media intensidad y luz intermitente. Equipado con 36 LEDs y botón de encendido/apagado. Su tamaño es ideal para acoplar en botellas, destacando en cualquier evento. 36 Ledes. 3 Posiciones de Luz. Batería 1200 mAh. Con sus modos de iluminación de alta visibilidad, tus botellas serán el centro de todas las miradas. Ideal para locales, discotecas, eventos VIP y bodas exclusivas. Personalízalo con tu marca o logotipo para destacar con estilo.",
    "specs": [
      "36 Ledes. 3 Posiciones de Luz. Batería 1200 mAh",
      "¿Quieres que tu evento, fiesta o servicio de botellas sea verdaderamente inolvidable? 🍾🌟",
      "Personalización exclusiva:",
      "Haz que tus celebraciones brillen con luz propia. ¡Preguntanos disponibilidad!"
    ],
    "image": "/catalog/baston-led-pexel_1.jpg",
    "images": [
      "/catalog/baston-led-pexel_1.jpg",
      "/catalog/baston-led-pexel_2.jpg",
      "/catalog/baston-led-pexel_3.jpg",
      "/catalog/baston-led-pexel_4.jpg",
      "/catalog/baston-led-pexel_5.jpg"
    ],
    "basePrice": 13.2,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Bastón Led Pexel",
    "titleEn": "Pexel LED Bottle Wand",
    "nameEn": "Pexel LED Bottle Wand",
    "categoryEn": "Sommelier Accessories",
    "descriptionEn": "LED bottle wand with 3 lighting modes (high, medium, strobe), 36 high-brightness LEDs, and 1200 mAh rechargeable battery.",
    "extendedDescriptionEn": "Designed to fit bottle necks and create an unforgettable light show. Featuring 36 bright LEDs and an easy power switch, it elevates nightlife venues, VIP bottle service, weddings, and premium brand activations.",
    "specsEn": [
      "36 High-output LEDs",
      "3 Lighting modes (High/Med/Strobe)",
      "1200 mAh rechargeable battery",
      "Fits standard champagne & wine necks"
    ]
  },
  {
    "id": "bolsa-enfriador-raycon",
    "name": "Bolsa Enfriador Raycon",
    "reference": "MK-003",
    "category": "Bolsas y Enfriadores",
    "description": "Original bolsa enfriador en PVC. Con resistentes asas reforzadas y líquido refrigerante en el interior.",
    "extendedDescription": "El vino siempre a su temperatura ideal, sin importar a dónde vayas. ❄️🍾 La Bolsa Enfriador Raycon es tu aliada perfecta para planes al aire libre, comidas y celebraciones. Original bolsa enfriador en PVC. Con resistentes asas reforzadas y líquido refrigerante en el interior. PVC. Cuenta con asas reforzadas para un transporte cómodo y seguro mientras mantiene la botella perfectamente fría.",
    "specs": [
      "PVC",
      "Personalización exclusiva:",
      "Despídete del vino caliente en tus reuniones. ¡Haz tu consulta y reserva la tuya!"
    ],
    "image": "/catalog/bolsa-enfriador-raycon_1.jpg",
    "images": [
      "/catalog/bolsa-enfriador-raycon_1.jpg",
      "/catalog/bolsa-enfriador-raycon_2.jpg",
      "/catalog/bolsa-enfriador-raycon_3.jpg"
    ],
    "basePrice": 3.55,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Bolsa Enfriador Raycon",
    "titleEn": "Raycon Chiller Wine Bag",
    "nameEn": "Raycon Chiller Wine Bag",
    "categoryEn": "Bags & Coolers",
    "descriptionEn": "Original PVC chiller bag with reinforced carry handles and built-in freezable cooling liquid.",
    "extendedDescriptionEn": "Keep your wine chilled wherever you go. The Raycon Chiller Bag is made of heavy-duty PVC with internal cooling gel and reinforced handles, delivering optimal serving temperature for outdoor tastings, catering, and summer celebrations.",
    "specsEn": [
      "Durable clear PVC",
      "Internal freezable cooling gel",
      "Reinforced handles",
      "Custom UV laser / screen print branding"
    ]
  },
  {
    "id": "bolsa-holden",
    "name": "Bolsa Holden",
    "reference": "MK-004",
    "category": "Bolsas y Enfriadores",
    "description": "Resistente bolsa de yute laminado para botella de vino de 75cl. Con ventana transparente, ribetes y asas reforzadas.",
    "extendedDescription": "La elegancia de lo natural: la mejor manera de vestir y regalar una buena botella de vino. 🌿🍷 Nuestra Bolsa Holden combina estética artesanal y máxima protección para tus botellas. Resistente bolsa de yute laminado para botella de vino de 75cl. Con ventana transparente, ribetes y asas reforzadas.. Confeccionada con materiales seleccionados y acabados reforzados que realzan la presencia de cualquier vino.",
    "specs": [
      "Personalización exclusiva:",
      "Convierte cada botella en una presentación de lujo. ¡Escríbenos para pedidos y presupuestos!"
    ],
    "image": "/catalog/bolsa-holden_1.jpg",
    "images": [
      "/catalog/bolsa-holden_1.jpg",
      "/catalog/bolsa-holden_2.jpg",
      "/catalog/bolsa-holden_3.jpg",
      "/catalog/bolsa-holden_4.jpg",
      "/catalog/bolsa-holden_5.jpg",
      "/catalog/bolsa-holden_6.jpg"
    ],
    "basePrice": 2.4,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Bolsa Holden",
    "titleEn": "Holden Jute Wine Bag",
    "nameEn": "Holden Jute Wine Bag",
    "categoryEn": "Bags & Coolers",
    "descriptionEn": "Resistant laminated natural jute bag for 75cl wine bottles, with clear viewing window, piping, and reinforced handles.",
    "extendedDescriptionEn": "Natural rustic elegance to present and gift fine wine. The Holden Bag combines natural laminated jute fiber with a transparent display window, offering maximum protection and premium shelf appeal for wineries and gourmet shops.",
    "specsEn": [
      "Natural laminated jute",
      "Transparent display window",
      "Reinforced stitching & carry handles",
      "Fits 75cl bottles"
    ]
  },
  {
    "id": "bolsa-koop",
    "name": "Bolsa Koop",
    "reference": "MK-005",
    "category": "Bolsas y Enfriadores",
    "description": "Resistente bolsa de yute laminado con compartimento individual para 2 botellas de vino de 75 cl. Con ventana transparente, ribetes y asas reforzadas.",
    "extendedDescription": "Porque una buena botella se disfruta, pero dos crean momentos inolvidables. 🍷🍷🌿 La Bolsa Koop es la forma más elegante y segura de presentar y transportar 2 botellas de vino. Resistente bolsa de yute laminado con compartimento individual para 2 botellas de vino de 75 cl. Con ventana transparente, ribetes y asas reforzadas. Yute Laminado. Confeccionada con materiales seleccionados y acabados reforzados que realzan la presencia de cualquier vino.",
    "specs": [
      "Yute Laminado",
      "Personalización exclusiva:",
      "Convierte cada botella en una presentación de lujo. ¡Escríbenos para pedidos y presupuestos!"
    ],
    "image": "/catalog/bolsa-koop_1.jpg",
    "images": [
      "/catalog/bolsa-koop_1.jpg",
      "/catalog/bolsa-koop_2.jpg",
      "/catalog/bolsa-koop_3.jpg",
      "/catalog/bolsa-koop_4.jpg",
      "/catalog/bolsa-koop_5.jpg",
      "/catalog/bolsa-koop_6.jpg"
    ],
    "basePrice": 3.8,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Bolsa Koop",
    "titleEn": "Koop Double Bottle Jute Bag",
    "nameEn": "Koop Double Bottle Jute Bag",
    "categoryEn": "Bags & Coolers",
    "descriptionEn": "Heavy-duty laminated jute carrier for 2 wine bottles of 75cl, with display window, internal divider, and reinforced handles.",
    "extendedDescriptionEn": "Because exceptional wines are best shared in pairs. The Koop Double Bottle Bag provides individual compartments to safely carry two bottles with elegant display windows and sturdy natural jute structure.",
    "specsEn": [
      "Heavy-duty laminated jute",
      "Double 75cl bottle capacity",
      "Internal protective divider",
      "Clear display front windows"
    ]
  },
  {
    "id": "bolsa-plesnik",
    "name": "Bolsa Plesnik",
    "reference": "MK-006",
    "category": "Bolsas y Enfriadores",
    "description": "Bolsa para botellas. Con cierre de cordón en yute e ideal para botellas de 750 ml.",
    "extendedDescription": "La elegancia de lo natural: la mejor manera de vestir y regalar una buena botella de vino. 🌿🍷 Nuestra Bolsa Plesnik combina estética artesanal y máxima protección para tus botellas. Bolsa para botellas. Con cierre de cordón en yute e ideal para botellas de 750 ml. Poliéster. Confeccionada con materiales seleccionados y acabados reforzados que realzan la presencia de cualquier vino.",
    "specs": [
      "Poliéster",
      "Personalización exclusiva:",
      "Convierte cada botella en una presentación de lujo. ¡Escríbenos para pedidos y presupuestos!"
    ],
    "image": "/catalog/bolsa-plesnik_1.jpg",
    "images": [
      "/catalog/bolsa-plesnik_1.jpg",
      "/catalog/bolsa-plesnik_2.jpg",
      "/catalog/bolsa-plesnik_3.jpg",
      "/catalog/bolsa-plesnik_4.jpg"
    ],
    "basePrice": 1.3,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Bolsa Plesnik",
    "titleEn": "Plesnik Drawstring Bottle Bag",
    "nameEn": "Plesnik Drawstring Bottle Bag",
    "categoryEn": "Bags & Coolers",
    "descriptionEn": "Natural textured bottle bag with jute drawstring closure, ideal for 750ml wine and champagne bottles.",
    "extendedDescriptionEn": "Classic artisanal packaging for wine bottles. Made with durable woven fabric and natural jute cords, the Plesnik bag turns any wine into a refined, ready-to-gift presentation.",
    "specsEn": [
      "Textured natural polyester weave",
      "Natural jute drawstring cord",
      "Fits standard 750ml bottles",
      "Ideal for winery retail & events"
    ]
  },
  {
    "id": "bolsa-yaiza",
    "name": "Bolsa Yaiza",
    "reference": "MK-007",
    "category": "Bolsas y Enfriadores",
    "description": "Bolsa de canvas de 220g/m2 para botella de vino de 75cl. En color natural, con resistente acabado cosido y asas reforzadas.",
    "extendedDescription": "La elegancia de lo natural: la mejor manera de vestir y regalar una buena botella de vino. 🌿🍷 Nuestra Bolsa Yaiza combina estética artesanal y máxima protección para tus botellas. Bolsa de canvas de 220g/m2 para botella de vino de 75cl. En color natural, con resistente acabado cosido y asas reforzadas. Canvas 220 g/ m2. Confeccionada con materiales seleccionados y acabados reforzados que realzan la presencia de cualquier vino.",
    "specs": [
      "Canvas 220 g/ m2",
      "Personalización exclusiva:",
      "Convierte cada botella en una presentación de lujo. ¡Escríbenos para pedidos y presupuestos!"
    ],
    "image": "/catalog/bolsa-yaiza_1.jpg",
    "images": [
      "/catalog/bolsa-yaiza_1.jpg",
      "/catalog/bolsa-yaiza_2.png",
      "/catalog/bolsa-yaiza_3.png"
    ],
    "basePrice": 1.95,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Bolsa Yaiza",
    "titleEn": "Yaiza 220g Canvas Wine Tote",
    "nameEn": "Yaiza 220g Canvas Wine Tote",
    "categoryEn": "Bags & Coolers",
    "descriptionEn": "Eco-friendly 220g/m² natural canvas tote for 75cl wine bottles with reinforced seams and handles.",
    "extendedDescriptionEn": "Sustainable and reusable luxury wine tote. Crafted from thick 220g/m² natural cotton canvas with reinforced stitching, providing superior durability for winery visits, gifts, and culinary events.",
    "specsEn": [
      "100% Natural canvas 220 g/m²",
      "Reinforced handles & stitching",
      "Eco-friendly & washable",
      "Custom laser & textile printing"
    ]
  },
  {
    "id": "bota-vino-1l",
    "name": "Bota Vino 1L",
    "reference": "MK-008",
    "category": "Accesorios de Sumiller",
    "description": "Bota de vino de 1l de capacidad en piel de serraje. Con tapón de seguridad a rosca y cinta bandolera. Homologada para uso alimentario",
    "extendedDescription": "El sabor de la tradición y la autenticidad que nunca pasa de moda. 🌄🍷 Auténtica bota de vino tradicional de 1 litro confeccionada en piel de serraje de primera calidad. Bota de vino de 1l de capacidad en piel de serraje. Con tapón de seguridad a rosca y cinta bandolera. Homologada para uso alimentario. Diseñada para acompañarte en el campo, senderismo, romerías o reuniones con amigos, con total comodidad y seguridad alimentaria.",
    "specs": [
      "Personalización exclusiva:",
      "Vuelve a beber como antes con un toque exclusivo. ¡Reserva la tuya hoy mismo!"
    ],
    "image": "/catalog/bota-vino-1l_1.jpg",
    "images": [
      "/catalog/bota-vino-1l_1.jpg",
      "/catalog/bota-vino-1l_2.jpg",
      "/catalog/bota-vino-1l_3.jpg",
      "/catalog/bota-vino-1l_4.jpg",
      "/catalog/bota-vino-1l_5.jpg"
    ],
    "basePrice": 15.5,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Bota Vino 1L",
    "titleEn": "Traditional 1L Leather Wine Bota",
    "nameEn": "Traditional 1L Leather Wine Bota",
    "categoryEn": "Sommelier Accessories",
    "descriptionEn": "Authentic 1-liter traditional Spanish wine skin bag made of premium split leather with safety screw cap and shoulder strap.",
    "extendedDescriptionEn": "The authentic taste of tradition that never fades. Handcrafted with genuine split leather, food-grade interior, and leak-proof screw nozzle. Perfect for outdoor gatherings, rural retreats, and cultural celebrations.",
    "specsEn": [
      "1 Liter capacity",
      "Genuine split leather exterior",
      "Certified food-safe interior lining",
      "Adjustable shoulder carry strap"
    ]
  },
  {
    "id": "caja-presentacion-baremon",
    "name": "Caja Presentacion Baremon",
    "reference": "MK-009",
    "category": "Estuches y Sets",
    "description": "Soporte de alta gama para vino y sumillería con acabado optimizado para personalización láser UV.",
    "extendedDescription": "Madera natural y corcho: la fusión rústica y distinguida que tus mejores botellas merecen. 🪵🍾🌿 La Caja de Presentación Baremon con su original formato cilíndrico de 34 cm de altura y 8 cm de diámetro está pensada para transformar cualquier botella de vino en un obsequio memorable. Su estructura combina la solidez de la madera natural en su interior con un exclusivo recubrimiento exterior en corcho natural auténtico y un cierre de correa en tono marrón. Una presentación cálida, ecológica y con un marcado carácter artesanal. El corcho natural exterior y la madera son lienzos excepcionales para el grabado láser: nombres de bodegas, fechas conmemorativas de bodas, iniciales o dedicatorias de empresa quedan con un relieve tostado y un contraste insuperable.",
    "specs": [
      "Personalización exclusiva:",
      "Convierte tu botella en un regalo inolvidable. ¡Pide tu caja Baremon personalizada!"
    ],
    "image": "/catalog/caja-presentacion-baremon_1.jpg",
    "images": [
      "/catalog/caja-presentacion-baremon_1.jpg",
      "/catalog/caja-presentacion-baremon_2.jpg",
      "/catalog/caja-presentacion-baremon_3.jpg",
      "/catalog/caja-presentacion-baremon_4.jpg"
    ],
    "basePrice": 5.7,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Caja Presentacion Baremon",
    "titleEn": "Baremon Cork & Wood Cylindrical Box",
    "nameEn": "Baremon Cork & Wood Cylindrical Box",
    "categoryEn": "Cases & Gift Sets",
    "descriptionEn": "Luxury cylindrical presentation box (34cm height x 8cm diameter) crafted with natural wood core and authentic cork exterior.",
    "extendedDescriptionEn": "Natural wood meets authentic cork in this prestigious presentation tube. Its cylindrical design with brown strap closure offers an ecological, artisanal unboxing experience that engraves beautifully with UV laser technology.",
    "specsEn": [
      "Height: 34 cm · Diameter: 8 cm",
      "Solid wood interior with natural cork wrap",
      "Strap latch closure",
      "High-contrast laser engraving finish"
    ]
  },
  {
    "id": "caja-presentacion-majan",
    "name": "Caja Presentacion Majan",
    "reference": "MK-010",
    "category": "Estuches y Sets",
    "description": "Soporte de alta gama para vino y sumillería con acabado optimizado para personalización láser UV.",
    "extendedDescription": "Líneas curvas, madera noble y presencia cilíndrica para sorprender desde el primer instante. 🪵🍷✨ La Caja de Presentación Majan rompe con lo convencional gracias a su original formato cilíndrico de 34 cm de altura y 8 cm de diámetro, perfecto para botellas de vino de 75 cl. Fabricada íntegramente en madera suave con tapadera superior a medida y un elegante cierre de cuerda con detalle en polipiel. Máxima protección y un empaque de prestigio. Su cuerpo de madera natural pulida es ideal para el grabado láser de logotipos de bodegas, frases conmemorativas, dedicatorias familiares o heráldica con un acabado de altísima definición.",
    "specs": [
      "Personalización exclusiva:",
      "La presentación que hace justicia a los grandes vinos. ¡Consúltanos opciones y presupuestos por privado!"
    ],
    "image": "/catalog/caja-presentacion-majan_1.jpg",
    "images": [
      "/catalog/caja-presentacion-majan_1.jpg",
      "/catalog/caja-presentacion-majan_2.jpg",
      "/catalog/caja-presentacion-majan_3.jpg",
      "/catalog/caja-presentacion-majan_4.jpg"
    ],
    "basePrice": 4.9,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Caja Presentacion Majan",
    "titleEn": "Majan Wooden Cylindrical Case",
    "nameEn": "Majan Wooden Cylindrical Case",
    "categoryEn": "Cases & Gift Sets",
    "descriptionEn": "Distinctive cylindrical presentation case for 75cl bottles, handcrafted in smooth natural wood with rope latch.",
    "extendedDescriptionEn": "Curves and noble timber create an unforgettable presentation. The Majan wooden cylindrical case fits standard 75cl bottles with a tailored top lid and leatherette-accented rope closure for maximum luxury appeal.",
    "specsEn": [
      "Height: 34 cm · Diameter: 8 cm",
      "Solid polished natural wood",
      "Rope & leatherette latch mechanism",
      "Optimal for winery logos & tributes"
    ]
  },
  {
    "id": "caja-presentacion-grimbur",
    "name": "Caja Presentación Grimbur",
    "reference": "MK-011",
    "category": "Estuches y Sets",
    "description": "Caja de presentación para 1 botella, fabricada en madera natural de Paulownia, ligera y resistente. Interior con sujeción de seguridad para el cuello de la botella, con tapa deslizante y cordón de transporte.",
    "extendedDescription": "La primera impresión lo es todo: presenta tus mejores botellas con el honor que merecen. 🪵🍷 La Caja Presentación Grimbur viste y protege tus botellas de vino con la nobleza de la madera natural. Caja de presentación para 1 botella, fabricada en madera natural de Paulownia, ligera y resistente. Interior con sujeción de seguridad para el cuello de la botella, con tapa deslizante y cordón de transporte. Madera. Su diseño con tapa deslizante y cordón rústico ofrece una presentación impecable y resistente.",
    "specs": [
      "Madera",
      "Personalización exclusiva:",
      "Transforma cualquier botella en un regalo memorable. ¡Contáctanos y personalízala!"
    ],
    "image": "/catalog/caja-presentacion-grimbur_1.jpg",
    "images": [
      "/catalog/caja-presentacion-grimbur_1.jpg",
      "/catalog/caja-presentacion-grimbur_2.jpg",
      "/catalog/caja-presentacion-grimbur_3.jpg",
      "/catalog/caja-presentacion-grimbur_4.jpg",
      "/catalog/caja-presentacion-grimbur_5.jpg"
    ],
    "basePrice": 5.7,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Caja Presentación Grimbur",
    "titleEn": "Grimbur Paulownia Wood Wine Box",
    "nameEn": "Grimbur Paulownia Wood Wine Box",
    "categoryEn": "Cases & Gift Sets",
    "descriptionEn": "Single bottle presentation box made of lightweight, sturdy Paulownia wood with sliding lid and bottle neck safety brace.",
    "extendedDescriptionEn": "First impressions define premium wine. The Grimbur box protects and showcases wine bottles in sustainable Paulownia wood, featuring an interior bottle neck stabilizer, sliding lid, and rustic carry cord.",
    "specsEn": [
      "Natural sustainable Paulownia wood",
      "Sliding wood cover",
      "Interior neck support holder",
      "Rustic braided carry cord"
    ]
  },
  {
    "id": "cubitera-tonend",
    "name": "Cubitera Tonend",
    "reference": "MK-012",
    "category": "Bolsas y Enfriadores",
    "description": "Original cubo de acero con exterior de madera. Forma de barril para conservar bebidas frías o hielos gracias a su doble pared de acero inox con 3L de capacidad.",
    "extendedDescription": "La Cubitera Tonend aúna la calidez rústica de la madera con la máxima eficacia térmica del acero inoxidable. Original cubo de acero con exterior de madera. Forma de barril para conservar bebidas frías o hielos gracias a su doble pared de acero inox con 3L de capacidad. 3 L Madera/ Acero Inox. Su doble pared interior conserva el hielo y mantiene las botellas a la temperatura ideal durante horas sin condensación exterior. Una pieza de gran valor estético y funcional que personalizamos a láser para bodegas, terrazas selectas y hogares con alma vinícola.",
    "specs": [
      "3 L",
      "Madera/ Acero Inox",
      "¿Una cubitera convencional? No, el auténtico encanto de una barrica en tu mesa. 🪵🧊🍾",
      "Personalización exclusiva:",
      "Lleva la magia del roble y el vino a tu mesa. ¡Escríbenos por privado para más información!"
    ],
    "image": "/catalog/cubitera-tonend_1.jpg",
    "images": [
      "/catalog/cubitera-tonend_1.jpg",
      "/catalog/cubitera-tonend_2.jpg",
      "/catalog/cubitera-tonend_3.jpg",
      "/catalog/cubitera-tonend_4.jpg"
    ],
    "basePrice": 45,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Cubitera Tonend",
    "titleEn": "Tonend Barrel Ice Bucket 3L",
    "nameEn": "Tonend Barrel Ice Bucket 3L",
    "categoryEn": "Bags & Coolers",
    "descriptionEn": "Double-wall stainless steel 3L ice bucket with authentic wooden barrel exterior for maximum thermal retention.",
    "extendedDescriptionEn": "The warmth of a rustic wine barrel combined with modern double-wall stainless steel efficiency. Keeps ice frozen and bottles chilled for hours without exterior condensation. A signature showpiece for wineries and wine lovers.",
    "specsEn": [
      "3 Liters capacity",
      "Double-wall stainless steel interior",
      "Natural wood barrel cladding",
      "Zero exterior condensation"
    ]
  },
  {
    "id": "decantador-pikerson",
    "name": "Decantador Pikerson",
    "reference": "MK-013",
    "category": "Decantadores",
    "description": "Decantador para vino de 1,8l de capacidad, con diseño estilizado y boca anti goteo.",
    "extendedDescription": "El arte de servir el vino: pureza, oxigenación y elegancia en cada copa. 🍷✨ El Decantador Pikerson está diseñado para que tus mejores caldos alcancen su máxima expresión aromática. Decantador para vino de 1,8l de capacidad, con diseño estilizado y boca anti goteo. 1,8 L Cristal. Su cuidada silueta facilita el vertido y permite una oxigenación óptima que despierta todos los matices del vino.",
    "specs": [
      "1,8 L",
      "Cristal",
      "Personalización exclusiva:",
      "Disfruta de una experiencia de cata superior. ¡Haz tu pedido ahora!"
    ],
    "image": "/catalog/decantador-pikerson_1.jpg",
    "images": [
      "/catalog/decantador-pikerson_1.jpg",
      "/catalog/decantador-pikerson_2.jpg",
      "/catalog/decantador-pikerson_3.jpg",
      "/catalog/decantador-pikerson_4.jpg"
    ],
    "basePrice": 19.2,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Decantador Pikerson",
    "titleEn": "Pikerson Crystal Wine Decanter 1.5L",
    "nameEn": "Pikerson Crystal Wine Decanter 1.5L",
    "categoryEn": "Decanters",
    "descriptionEn": "1500ml lead-free crystalline decanter with wide aeration base and slanted pour spout for optimal wine breathing.",
    "extendedDescriptionEn": "Hand-blown styling engineered to unleash the hidden aromatic bouquet of red wines. The wide ergonomic base maximizes oxygen contact while the drip-free slanted rim guarantees effortless pouring.",
    "specsEn": [
      "1500 ml capacity",
      "Lead-free acoustic crystal glass",
      "Wide aeration base",
      "Precision laser-etched personalization"
    ]
  },
  {
    "id": "decantador-seirten",
    "name": "Decantador Seirten",
    "reference": "MK-014",
    "category": "Decantadores",
    "description": "Decantador, fabricado en cristal de borosilicato y con base y tapón en corcho natural. De 1,7L de capacidad .",
    "extendedDescription": "El arte de servir el vino: pureza, oxigenación y elegancia en cada copa. 🍷✨ El Decantador Seirten está diseñado para que tus mejores caldos alcancen su máxima expresión aromática. Decantador, fabricado en cristal de borosilicato y con base y tapón en corcho natural. De 1,7L de capacidad . 1,7 L Cristal Borosilicato/ Corcho. Su cuidada silueta facilita el vertido y permite una oxigenación óptima que despierta todos los matices del vino.",
    "specs": [
      "1,7 L",
      "Cristal Borosilicato/ Corcho",
      "Personalización exclusiva:",
      "Disfruta de una experiencia de cata superior. ¡Haz tu pedido ahora!"
    ],
    "image": "/catalog/decantador-seirten_1.jpg",
    "images": [
      "/catalog/decantador-seirten_1.jpg",
      "/catalog/decantador-seirten_2.jpg",
      "/catalog/decantador-seirten_3.jpg",
      "/catalog/decantador-seirten_4.jpg"
    ],
    "basePrice": 25.7,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Decantador Seirten",
    "titleEn": "Seirten Contemporary Decanter 1.2L",
    "nameEn": "Seirten Contemporary Decanter 1.2L",
    "categoryEn": "Decanters",
    "descriptionEn": "Modern 1200ml wine decanter with ergonomic grip neck and flared base for swift tannin softening.",
    "extendedDescriptionEn": "Contemporary lines for avant-garde tables. The Seirten decanter allows smooth swirling and controlled oxidation, highlighting the nuances of reserve and vintage wines.",
    "specsEn": [
      "1200 ml capacity",
      "Ergonomic pour neck",
      "Ultra-clear crystalline glass",
      "Dishwasher safe & scratch-resistant"
    ]
  },
  {
    "id": "enfriador-boreas",
    "name": "Enfriador Boreas",
    "reference": "MK-015",
    "category": "Bolsas y Enfriadores",
    "description": "Enfriador de botellas de práctico diseño. Adaptable a cualquier tipo de botella mediante su banda elástica negra que va desde la parte superior a la inferior. Es perfecto para meter en el congelador y mantener la temperatura de la botella durante más tiempo.",
    "extendedDescription": "Disfruta de cada sorbo a la temperatura perfecta de principio a fin. ❄️🍷 El Enfriador Boreas mantiene tus botellas de vino blanco, rosado o espumoso frescas durante toda la velada. Enfriador de botellas de práctico diseño. Adaptable a cualquier tipo de botella mediante su banda elástica negra que va desde la parte superior a la inferior. Es perfecto para meter en el congelador y mantener la temperatura de la botella durante más tiempo. Ajustable Poliéster. Diseñado para ofrecer practicidad, durabilidad y un servicio de mesa impecable sin goteos de hielo.",
    "specs": [
      "Ajustable",
      "Poliéster",
      "Personalización exclusiva:",
      "Asegura el brindis perfecto en todo momento. ¡Escríbenos y consulta opciones!"
    ],
    "image": "/catalog/enfriador-boreas_1.jpg",
    "images": [
      "/catalog/enfriador-boreas_1.jpg",
      "/catalog/enfriador-boreas_2.jpg",
      "/catalog/enfriador-boreas_3.jpg",
      "/catalog/enfriador-boreas_4.jpg",
      "/catalog/enfriador-boreas_5.jpg",
      "/catalog/enfriador-boreas_6.jpg"
    ],
    "basePrice": 4.1,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Enfriador Boreas",
    "titleEn": "Boreas Stainless Steel Bottle Cooler",
    "nameEn": "Boreas Stainless Steel Bottle Cooler",
    "categoryEn": "Bags & Coolers",
    "descriptionEn": "Double-wall stainless steel wine chiller sleeve with satin finish, keeping bottles at optimal serving temperature.",
    "extendedDescriptionEn": "Thermal insulation without wet ice or dripping bottles. The Boreas cooler uses double-wall vacuum engineering to maintain chilled whites, rosés, and sparkling wines throughout prolonged meals.",
    "specsEn": [
      "High-grade food stainless steel",
      "Double-wall thermal vacuum",
      "Fingerprint-resistant satin exterior",
      "Fits standard wine & cava bottles"
    ]
  },
  {
    "id": "enfriador-nohan",
    "name": "Enfriador Nohan",
    "reference": "MK-016",
    "category": "Bolsas y Enfriadores",
    "description": "Enfriador, fabricado en acero inox de acabado mate para 1 botella.",
    "extendedDescription": "Disfruta de cada sorbo a la temperatura perfecta de principio a fin. ❄️🍷 El Enfriador Nohan mantiene tus botellas de vino blanco, rosado o espumoso frescas durante toda la velada. Enfriador, fabricado en acero inox de acabado mate para 1 botella. Acero Inox. Diseñado para ofrecer practicidad, durabilidad y un servicio de mesa impecable sin goteos de hielo.",
    "specs": [
      "Acero Inox",
      "Personalización exclusiva:",
      "Asegura el brindis perfecto en todo momento. ¡Escríbenos y consulta opciones!"
    ],
    "image": "/catalog/enfriador-nohan_1.jpg",
    "images": [
      "/catalog/enfriador-nohan_1.jpg",
      "/catalog/enfriador-nohan_2.png",
      "/catalog/enfriador-nohan_3.png",
      "/catalog/enfriador-nohan_4.png"
    ],
    "basePrice": 17.8,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Enfriador Nohan",
    "titleEn": "Nohan Neoprene Chiller Sleeve",
    "nameEn": "Nohan Neoprene Chiller Sleeve",
    "categoryEn": "Bags & Coolers",
    "descriptionEn": "Flexible insulating neoprene sleeve with side elastic gussets, easily chilling and protecting 75cl bottles.",
    "extendedDescriptionEn": "Lightweight, shock-absorbing, and thermally efficient. The Nohan sleeve slips over chilled bottles to trap coldness and provide comfortable, slip-free handling during outdoor tastings and barbecues.",
    "specsEn": [
      "High-density insulating neoprene",
      "Stretch elastic side panels",
      "Compact & travel friendly",
      "Full-color laser / transfer ready"
    ]
  },
  {
    "id": "enfriador-nuisant",
    "name": "Enfriador Nuisant",
    "reference": "MK-017",
    "category": "Bolsas y Enfriadores",
    "description": "Enfriador para botellas fabricado en resistente PVC, con cierre ajustable de velcro. Líquido refrigerante interior y acabado termo sellado.",
    "extendedDescription": "Disfruta de cada sorbo a la temperatura perfecta de principio a fin. ❄️🍷 El Enfriador Nuisant mantiene tus botellas de vino blanco, rosado o espumoso frescas durante toda la velada. Enfriador para botellas fabricado en resistente PVC, con cierre ajustable de velcro. Líquido refrigerante interior y acabado termo sellado. PVC. Diseñado para ofrecer practicidad, durabilidad y un servicio de mesa impecable sin goteos de hielo.",
    "specs": [
      "PVC",
      "Personalización exclusiva:",
      "Asegura el brindis perfecto en todo momento. ¡Escríbenos y consulta opciones!"
    ],
    "image": "/catalog/enfriador-nuisant_1.jpg",
    "images": [
      "/catalog/enfriador-nuisant_1.jpg",
      "/catalog/enfriador-nuisant_2.jpg",
      "/catalog/enfriador-nuisant_3.jpg",
      "/catalog/enfriador-nuisant_4.jpg",
      "/catalog/enfriador-nuisant_5.jpg",
      "/catalog/enfriador-nuisant_6.jpg"
    ],
    "basePrice": 2.6,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Enfriador Nuisant",
    "titleEn": "Nuisant Rapid Cooling Gel Sleeve",
    "nameEn": "Nuisant Rapid Cooling Gel Sleeve",
    "categoryEn": "Bags & Coolers",
    "descriptionEn": "Rapid freezer cooling sleeve with active non-toxic gel cells and velcro closure to fit all bottle silhouettes.",
    "extendedDescriptionEn": "Chill room-temperature wine down to cellar temperature in minutes. Store the Nuisant sleeve in your freezer, wrap it around your bottle, and enjoy crisp wine anywhere with adjustable velcro security.",
    "specsEn": [
      "Sub-zero active cooling gel cells",
      "Adjustable velcro wrap design",
      "Chills bottles in under 10 minutes",
      "Durable tear-proof nylon shell"
    ]
  },
  {
    "id": "identificador-copas-emelya",
    "name": "Identificador Copas Emelya",
    "reference": "MK-018",
    "category": "Copas y Cristal",
    "description": "Soporte de alta gama para vino y sumillería con acabado optimizado para personalización láser UV.",
    "extendedDescription": "El set Identificador Copas Emelya es el accesorio imprescindible para reuniones, catas de vino, cócteles y bodas. Se coloca con total suavidad y elegancia en el tallo de cada copa, permitiendo a cada invitado reconocer su bebida al instante sin alterar la degustación. Personalizamos a láser cada pieza con nombres, iniciales, números de mesa o motivos exclusivos para eventos y recuerdos de boda únicos.",
    "specs": [
      "¿De quién es esta copa? Despídete de las confusiones en tus eventos con estilo y distinción. 🍷🏷️🥂",
      "Personalización exclusiva:",
      "Añade un toque de etiqueta y buen gusto a tus celebraciones. ¡Pide tu set personalizado!"
    ],
    "image": "/catalog/identificador-copas-emelya_1.jpg",
    "images": [
      "/catalog/identificador-copas-emelya_1.jpg",
      "/catalog/identificador-copas-emelya_2.jpg",
      "/catalog/identificador-copas-emelya_3.jpg",
      "/catalog/identificador-copas-emelya_4.jpg",
      "/catalog/identificador-copas-emelya_5.jpg"
    ],
    "basePrice": 2.1,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Identificador Copas Emelya",
    "titleEn": "Emelya Glass Stem Markers (Set of 6)",
    "nameEn": "Emelya Glass Stem Markers (Set of 6)",
    "categoryEn": "Glassware & Glasses",
    "descriptionEn": "Set of 6 distinct metallic ring stem markers with assorted natural wooden charms for wine glasses.",
    "extendedDescriptionEn": "Never confuse glasses at social gatherings again. The Emelya set features 6 finely polished wood and metal charms that clasp onto glass stems, easily engraved with guest names, initials, or table numbers.",
    "specsEn": [
      "Set of 6 units",
      "Natural polished wood & brass clasps",
      "Fits all standard wine & cava stems",
      "Customized micro-engraving"
    ]
  },
  {
    "id": "llavero-abridor-jilar",
    "name": "Llavero Abridor Jilar",
    "reference": "MK-019",
    "category": "Sacacorchos y Abridores",
    "description": "Llavero abridor fabricado en bambú y acero inox, con abridor de botellas y sacacorchos, incluye cuchilla y argolla de metal para llaves.",
    "extendedDescription": "Lleva contigo la pasión por los buenos momentos allá donde vayas. 🔑🍇🍾 El Llavero Abridor Jilar es más que un accesorio: es un homenaje al mundo del vino y la artesanía. Llavero abridor fabricado en bambú y acero inox, con abridor de botellas y sacacorchos, incluye cuchilla y argolla de metal para llaves. Bambú/ Acero Inox. Compacto, ligero y práctico para el día a día.",
    "specs": [
      "Bambú/ Acero Inox",
      "Personalización exclusiva:",
      "El detalle perfecto para regalar en cualquier ocasión. ¡Consúltanos por privado!"
    ],
    "image": "/catalog/llavero-abridor-jilar_1.jpg",
    "images": [
      "/catalog/llavero-abridor-jilar_1.jpg",
      "/catalog/llavero-abridor-jilar_2.jpg",
      "/catalog/llavero-abridor-jilar_3.jpg",
      "/catalog/llavero-abridor-jilar_4.jpg",
      "/catalog/llavero-abridor-jilar_5.jpg",
      "/catalog/llavero-abridor-jilar_6.jpg"
    ],
    "basePrice": 1.75,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Llavero Abridor Jilar",
    "titleEn": "Jilar Keychain Bottle Opener",
    "nameEn": "Jilar Keychain Bottle Opener",
    "categoryEn": "Corkscrews & Openers",
    "descriptionEn": "Compact anodized aluminum keychain with integrated crown cap lifter and smooth laser engraving surface.",
    "extendedDescriptionEn": "Always at hand on your key ring. The Jilar opener combines lightweight aircraft-grade aluminum with an ergonomic lever designed to pop bottle caps effortlessly.",
    "specsEn": [
      "Lightweight anodized aluminum",
      "Heavy-duty keyring included",
      "Wear-resistant laser finish",
      "Available in assorted metallic tones"
    ]
  },
  {
    "id": "llavero-telsox",
    "name": "Llavero Telsox",
    "reference": "MK-020",
    "category": "Accesorios de Sumiller",
    "description": "Llavero enólogo de corcho natural.",
    "extendedDescription": "Lleva contigo la pasión por los buenos momentos allá donde vayas. 🔑🍇🍾 El Llavero Telsox es más que un accesorio: es un homenaje al mundo del vino y la artesanía. Llavero enólogo de corcho natural. Corcho. Compacto, ligero y práctico para el día a día.",
    "specs": [
      "Corcho",
      "Personalización exclusiva:",
      "El detalle perfecto para regalar en cualquier ocasión. ¡Consúltanos por privado!"
    ],
    "image": "/catalog/llavero-telsox_1.jpg",
    "images": [
      "/catalog/llavero-telsox_1.jpg",
      "/catalog/llavero-telsox_2.jpg",
      "/catalog/llavero-telsox_3.jpg"
    ],
    "basePrice": 1.1,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Llavero Telsox",
    "titleEn": "Telsox Bamboo Sommelier Keychain",
    "nameEn": "Telsox Bamboo Sommelier Keychain",
    "categoryEn": "Sommelier Accessories",
    "descriptionEn": "Eco-friendly natural bamboo and zinc alloy keychain with multi-purpose corkscrew and bottle opener.",
    "extendedDescriptionEn": "Sleek bamboo body paired with robust zinc alloy hardware. A pocket sommelier accessory that delivers genuine utility with a natural, organic finish.",
    "specsEn": [
      "Natural sustainable bamboo",
      "Zinc alloy hardware",
      "Foldable corkscrew & cap opener",
      "Warm laser-burned wood contrast"
    ]
  },
  {
    "id": "mesa-zarbok",
    "name": "Mesa Zarbok",
    "reference": "MK-021",
    "category": "Accesorios de Sumiller",
    "description": "Mesa plegable para los aficionados al mundo del vino. Fabricada en bambú, incluye compartimento para botella de 75cl y 2 soportes para copa. De fácil plegado y tamaño compacto.",
    "extendedDescription": "El picnic soñado de cualquier amante del buen vino hecho realidad. 🧺🍷🌿 La Mesa Zarbok está creada para disfrutar de tus momentos de relax al aire libre con total comodidad. Mesa plegable para los aficionados al mundo del vino. Fabricada en bambú, incluye compartimento para botella de 75cl y 2 soportes para copa. De fácil plegado y tamaño compacto. Plegable Bambú. Su diseño plegable y estable sostiene tu botella y copas de forma segura en césped, arena o terraza.",
    "specs": [
      "Plegable",
      "Bambú",
      "Personalización exclusiva:",
      "Convierte cualquier escapada en una experiencia de ensueño. ¡Escríbenos y encarga la tuya!"
    ],
    "image": "/catalog/mesa-zarbok_1.jpg",
    "images": [
      "/catalog/mesa-zarbok_1.jpg",
      "/catalog/mesa-zarbok_2.jpg",
      "/catalog/mesa-zarbok_3.jpg",
      "/catalog/mesa-zarbok_4.jpg"
    ],
    "basePrice": 6.1,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Mesa Zarbok",
    "titleEn": "Zarbok Foldable Outdoor Wine Table",
    "nameEn": "Zarbok Foldable Outdoor Wine Table",
    "categoryEn": "Sommelier Accessories",
    "descriptionEn": "Foldable natural wood picnic table with ground stake, bottle stabilizer, and 2 wine glass resting slots.",
    "extendedDescriptionEn": "Turn any vineyard lawn or beach into a private wine lounge. The Zarbok table stakes firmly into soil or sand, holding a wine bottle securely alongside two suspended stem glasses.",
    "specsEn": [
      "100% Solid pine wood",
      "Holds 1 bottle & 2 stem glasses",
      "Foldable with ground spike",
      "Custom laser engraved tabletop"
    ]
  },
  {
    "id": "navaja-multiusos-kasuki",
    "name": "Navaja Multiusos Kasuki",
    "reference": "MK-022",
    "category": "Accesorios de Sumiller",
    "description": "Navaja multiusos fabricada en acero inox y suave bambú. Con 9 funciones que incluyen cuchillo, tijeras, abrelatas, sacacorchos, destornillador philips, destornillador plano, lima y abrebotellas. Además, cuenta con un práctico enganche en forma de mosquetón.",
    "extendedDescription": "Robustez, precisión y versatilidad: las herramientas que necesitas siempre a mano. 🌲🔪🛠️ La Navaja Multiusos Kasuki está construida para acompañarte en tus aventuras, jornadas de campo o tareas del día a día. Navaja multiusos fabricada en acero inox y suave bambú. Con 9 funciones que incluyen cuchillo, tijeras, abrelatas, sacacorchos, destornillador philips, destornillador plano, lima y abrebotellas. Además, cuenta con un práctico enganche en forma de mosquetón. 9 Funciones Bambú/ Acero Inox. Herramientas en acero inoxidable de gran precisión ensambladas en una estructura ergonómica y duradera.",
    "specs": [
      "9 Funciones",
      "Bambú/ Acero Inox",
      "Personalización exclusiva:",
      "Equípate con una compañera para toda la vida. ¡Haz tu pedido ahora!"
    ],
    "image": "/catalog/navaja-multiusos-kasuki_1.jpg",
    "images": [
      "/catalog/navaja-multiusos-kasuki_1.jpg",
      "/catalog/navaja-multiusos-kasuki_2.jpg",
      "/catalog/navaja-multiusos-kasuki_3.jpg",
      "/catalog/navaja-multiusos-kasuki_4.jpg",
      "/catalog/navaja-multiusos-kasuki_5.jpg"
    ],
    "basePrice": 5.2,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Navaja Multiusos Kasuki",
    "titleEn": "Kasuki Multi-Tool Sommelier Knife",
    "nameEn": "Kasuki Multi-Tool Sommelier Knife",
    "categoryEn": "Sommelier Accessories",
    "descriptionEn": "Stainless steel pocket knife with natural wooden scales, corkscrew, foil cutter blade, and bottle opener.",
    "extendedDescriptionEn": "Classic outdoor companion crafted with polished natural wood grips and stainless steel tools. Features a precision spiral corkscrew and serrated capsule cutter.",
    "specsEn": [
      "Stainless steel blades & tools",
      "Natural grain wood handles",
      "5 Essential functions",
      "Compact safety folding design"
    ]
  },
  {
    "id": "navaja-multiusos-klent",
    "name": "Navaja Multiusos Klent",
    "reference": "MK-023",
    "category": "Accesorios de Sumiller",
    "description": "Navaja multiusos de orizons con accesorios de acero inox de 10 funciones y mango de aluminio. Con navaja, tijeras, abrelatas, abrebotellas con destornillador plano, destornillador de punta de estrella, punzón con lima y sacacorchos. Con anilla para llavero.",
    "extendedDescription": "Robustez, precisión y versatilidad: las herramientas que necesitas siempre a mano. 🌲🔪🛠️ La Navaja Multiusos Klent está construida para acompañarte en tus aventuras, jornadas de campo o tareas del día a día. Navaja multiusos de orizons con accesorios de acero inox de 10 funciones y mango de aluminio. Con navaja, tijeras, abrelatas, abrebotellas con destornillador plano, destornillador de punta de estrella, punzón con lima y sacacorchos. Con anilla para llavero. 10 Funciones Aluminio/ Acero Inox. Herramientas en acero inoxidable de gran precisión ensambladas en una estructura ergonómica y duradera.",
    "specs": [
      "10 Funciones",
      "Aluminio/ Acero Inox",
      "Personalización exclusiva:",
      "Equípate con una compañera para toda la vida. ¡Haz tu pedido ahora!"
    ],
    "image": "/catalog/navaja-multiusos-klent_1.jpg",
    "images": [
      "/catalog/navaja-multiusos-klent_1.jpg",
      "/catalog/navaja-multiusos-klent_2.jpg",
      "/catalog/navaja-multiusos-klent_3.jpg",
      "/catalog/navaja-multiusos-klent_4.jpg",
      "/catalog/navaja-multiusos-klent_5.jpg",
      "/catalog/navaja-multiusos-klent_6.jpg"
    ],
    "basePrice": 4.7,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Navaja Multiusos Klent",
    "titleEn": "Klent Walnut Wood Pocket Knife",
    "nameEn": "Klent Walnut Wood Pocket Knife",
    "categoryEn": "Sommelier Accessories",
    "descriptionEn": "7-Function multi-tool knife with dark walnut handle, stainless steel corkscrew, can opener, and saw.",
    "extendedDescriptionEn": "Rich dark wood handle with polished steel bolsters. Built for durability, offering a complete set of culinary and sommelier tools for field tastings and daily versatility.",
    "specsEn": [
      "Rich walnut handle scales",
      "7 Multi-purpose stainless tools",
      "Sturdy backspring mechanism",
      "Laser marked logo surface"
    ]
  },
  {
    "id": "navaja-multiusos-lixthel",
    "name": "Navaja Multiusos Lixthel",
    "reference": "MK-024",
    "category": "Accesorios de Sumiller",
    "description": "Navaja multiusos con accesorios de acero inox con 5 funciones, con recubrimiento de resistente ABS. Incluye cuchillo, punzón, sacacorchos, abrelatas y abrebotellas.",
    "extendedDescription": "Robustez, precisión y versatilidad: las herramientas que necesitas siempre a mano. 🌲🔪🛠️ La Navaja Multiusos Lixthel está construida para acompañarte en tus aventuras, jornadas de campo o tareas del día a día. Navaja multiusos con accesorios de acero inox con 5 funciones, con recubrimiento de resistente ABS. Incluye cuchillo, punzón, sacacorchos, abrelatas y abrebotellas. 5 Funciones Acero Inox. Herramientas en acero inoxidable de gran precisión ensambladas en una estructura ergonómica y duradera.",
    "specs": [
      "5 Funciones",
      "Acero Inox",
      "Personalización exclusiva:",
      "Equípate con una compañera para toda la vida. ¡Haz tu pedido ahora!"
    ],
    "image": "/catalog/navaja-multiusos-lixthel_1.jpg",
    "images": [
      "/catalog/navaja-multiusos-lixthel_1.jpg",
      "/catalog/navaja-multiusos-lixthel_2.jpg",
      "/catalog/navaja-multiusos-lixthel_3.jpg",
      "/catalog/navaja-multiusos-lixthel_4.jpg"
    ],
    "basePrice": 7.8,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Navaja Multiusos Lixthel",
    "titleEn": "Lixthel Slim Sommelier Knife",
    "nameEn": "Lixthel Slim Sommelier Knife",
    "categoryEn": "Sommelier Accessories",
    "descriptionEn": "Ultra-slim ergonomic multi-tool knife with aluminum casing, precision corkscrew, and capsule cutter.",
    "extendedDescriptionEn": "Minimalist design meets professional performance. The Lixthel knife slips into any pocket without bulk, delivering smooth cork extraction and crisp foil cutting.",
    "specsEn": [
      "Anodized satin aluminum body",
      "5-Turn teflon corkscrew spiral",
      "Serrated foil trimmer blade",
      "Featherlight pocket profile"
    ]
  },
  {
    "id": "navaja-multiusos-mansni",
    "name": "Navaja Multiusos Mansni",
    "reference": "MK-025",
    "category": "Accesorios de Sumiller",
    "description": "Navaja multiusos con accesorios de acero inox con 8 funciones, con recubrimiento de resistente ABS. Incluye dos cuchillos en tamaños diferentes, punzón, sacacorchos, palillo de dientes, aguja de coser, abrelatas y abrebotellas.",
    "extendedDescription": "Robustez, precisión y versatilidad: las herramientas que necesitas siempre a mano. 🌲🔪🛠️ La Navaja Multiusos Mansni está construida para acompañarte en tus aventuras, jornadas de campo o tareas del día a día. Navaja multiusos con accesorios de acero inox con 8 funciones, con recubrimiento de resistente ABS. Incluye dos cuchillos en tamaños diferentes, punzón, sacacorchos, palillo de dientes, aguja de coser, abrelatas y abrebotellas. 8 Funciones Acero Inox. Herramientas en acero inoxidable de gran precisión ensambladas en una estructura ergonómica y duradera.",
    "specs": [
      "8 Funciones",
      "Acero Inox",
      "Personalización exclusiva:",
      "Equípate con una compañera para toda la vida. ¡Haz tu pedido ahora!"
    ],
    "image": "/catalog/navaja-multiusos-mansni_1.jpg",
    "images": [
      "/catalog/navaja-multiusos-mansni_1.jpg",
      "/catalog/navaja-multiusos-mansni_2.jpg",
      "/catalog/navaja-multiusos-mansni_3.jpg",
      "/catalog/navaja-multiusos-mansni_4.jpg"
    ],
    "basePrice": 6.5,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Navaja Multiusos Mansni",
    "titleEn": "Mansni Heavy-Duty Multi-Tool Knife",
    "nameEn": "Mansni Heavy-Duty Multi-Tool Knife",
    "categoryEn": "Sommelier Accessories",
    "descriptionEn": "Heavy-duty multi-tool with Pakkawood handle scales, high-carbon stainless blades, and dual-lever sommelier opener.",
    "extendedDescriptionEn": "Built for demanding professionals. Combines handsome moisture-resistant Pakkawood grips with heavy-gauge stainless steel components that withstand thousands of bottle openings.",
    "specsEn": [
      "Moisture-resistant Pakkawood scales",
      "Reinforced stainless steel pivots",
      "Dual-step sommelier boot lever",
      "Presentation gift box included"
    ]
  },
  {
    "id": "navaja-multiusos-mixtil",
    "name": "Navaja Multiusos Mixtil",
    "reference": "MK-026",
    "category": "Accesorios de Sumiller",
    "description": "Navaja multiusos con accesorios de acero inox con 10 funciones, con recubrimiento de resistente ABS. Incluye cuchilla, tijeras, pinzas, brújula, lima de uñas, punzón, sacacorchos, palillo de dientes, destornillador, abrelatas y abrebotellas.",
    "extendedDescription": "Robustez, precisión y versatilidad: las herramientas que necesitas siempre a mano. 🌲🔪🛠️ La Navaja Multiusos Mixtil está construida para acompañarte en tus aventuras, jornadas de campo o tareas del día a día. Navaja multiusos con accesorios de acero inox con 10 funciones, con recubrimiento de resistente ABS. Incluye cuchilla, tijeras, pinzas, brújula, lima de uñas, punzón, sacacorchos, palillo de dientes, destornillador, abrelatas y abrebotellas. 10 Funciones Acero Inox. Herramientas en acero inoxidable de gran precisión ensambladas en una estructura ergonómica y duradera.",
    "specs": [
      "10 Funciones",
      "Acero Inox",
      "Personalización exclusiva:",
      "Equípate con una compañera para toda la vida. ¡Haz tu pedido ahora!"
    ],
    "image": "/catalog/navaja-multiusos-mixtil_1.jpg",
    "images": [
      "/catalog/navaja-multiusos-mixtil_1.jpg",
      "/catalog/navaja-multiusos-mixtil_2.jpg",
      "/catalog/navaja-multiusos-mixtil_3.jpg",
      "/catalog/navaja-multiusos-mixtil_4.jpg",
      "/catalog/navaja-multiusos-mixtil_5.jpg"
    ],
    "basePrice": 5.9,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Navaja Multiusos Mixtil",
    "titleEn": "Mixtil Olive Wood Sommelier Knife",
    "nameEn": "Mixtil Olive Wood Sommelier Knife",
    "categoryEn": "Sommelier Accessories",
    "descriptionEn": "Fine sommelier pocket knife with authentic Mediterranean olive wood handle and engraved spine.",
    "extendedDescriptionEn": "A tribute to Mediterranean terroir. The unique grain of genuine olive wood makes every piece one-of-a-kind, paired with a hand-tuned corkscrew and foil blade.",
    "specsEn": [
      "Genuine olive wood handle",
      "Hand-finished satin bolster",
      "Precision 5-twist worm",
      "Luxury presentation packaging"
    ]
  },
  {
    "id": "navaja-multiusos-texwol",
    "name": "Navaja Multiusos Texwol",
    "reference": "MK-027",
    "category": "Accesorios de Sumiller",
    "description": "Navaja multiusos con accesorios de acero inox con 10 funciones, con recubrimiento de resistente ABS. Incluye dos cuchillos en tamaños diferentes, tijeras, pinzas, alicates, punzón, sacacorchos, palillo de dientes, aguja de coser, abrelatas y abrebotellas.",
    "extendedDescription": "Robustez, precisión y versatilidad: las herramientas que necesitas siempre a mano. 🌲🔪🛠️ La Navaja Multiusos Texwol está construida para acompañarte en tus aventuras, jornadas de campo o tareas del día a día. Navaja multiusos con accesorios de acero inox con 10 funciones, con recubrimiento de resistente ABS. Incluye dos cuchillos en tamaños diferentes, tijeras, pinzas, alicates, punzón, sacacorchos, palillo de dientes, aguja de coser, abrelatas y abrebotellas. 10 Funciones Acero Inox. Herramientas en acero inoxidable de gran precisión ensambladas en una estructura ergonómica y duradera.",
    "specs": [
      "10 Funciones",
      "Acero Inox",
      "Personalización exclusiva:",
      "Equípate con una compañera para toda la vida. ¡Haz tu pedido ahora!"
    ],
    "image": "/catalog/navaja-multiusos-texwol_1.jpg",
    "images": [
      "/catalog/navaja-multiusos-texwol_1.jpg",
      "/catalog/navaja-multiusos-texwol_2.jpg",
      "/catalog/navaja-multiusos-texwol_3.jpg",
      "/catalog/navaja-multiusos-texwol_4.jpg",
      "/catalog/navaja-multiusos-texwol_5.jpg"
    ],
    "basePrice": 7.95,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Navaja Multiusos Texwol",
    "titleEn": "Texwol Textured Grip Sommelier Knife",
    "nameEn": "Texwol Textured Grip Sommelier Knife",
    "categoryEn": "Sommelier Accessories",
    "descriptionEn": "Modern textured-grip pocket knife with high-strength non-slip scales, grooved corkscrew, and lever opener.",
    "extendedDescriptionEn": "Engineered for superior grip even with damp hands in busy restaurant service. The textured composite handle pairs with reliable stainless steel mechanisms.",
    "specsEn": [
      "Non-slip textured composite handle",
      "High-carbon stainless steel",
      "Integrated cap lifter & cork extractor",
      "Long-lasting sharpness"
    ]
  },
  {
    "id": "navaja-multiusos-titan",
    "name": "Navaja Multiusos Titan",
    "reference": "MK-028",
    "category": "Accesorios de Sumiller",
    "description": "Navaja multiusos, en combinación de materiales bambú y acero inox, con 9 funciones. Incluye navaja, abridores, tijeras, lima, destornillador, sacacorchos… Con cinta para transporte en polipiel.",
    "extendedDescription": "Robustez, precisión y versatilidad: las herramientas que necesitas siempre a mano. 🌲🔪🛠️ La Navaja Multiusos Titan está construida para acompañarte en tus aventuras, jornadas de campo o tareas del día a día. Navaja multiusos, en combinación de materiales bambú y acero inox, con 9 funciones. Incluye navaja, abridores, tijeras, lima, destornillador, sacacorchos… Con cinta para transporte en polipiel. 9 Funciones Bambú/ Acero Inox. Herramientas en acero inoxidable de gran precisión ensambladas en una estructura ergonómica y duradera.",
    "specs": [
      "9 Funciones",
      "Bambú/ Acero Inox",
      "Personalización exclusiva:",
      "Equípate con una compañera para toda la vida. ¡Haz tu pedido ahora!"
    ],
    "image": "/catalog/navaja-multiusos-titan_1.jpg",
    "images": [
      "/catalog/navaja-multiusos-titan_1.jpg",
      "/catalog/navaja-multiusos-titan_2.jpg",
      "/catalog/navaja-multiusos-titan_3.jpg",
      "/catalog/navaja-multiusos-titan_4.jpg",
      "/catalog/navaja-multiusos-titan_5.jpg"
    ],
    "basePrice": 3.5,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Navaja Multiusos Titan",
    "titleEn": "Titan Matte Black Multi-Tool Knife",
    "nameEn": "Titan Matte Black Multi-Tool Knife",
    "categoryEn": "Sommelier Accessories",
    "descriptionEn": "Stealth matte black stainless steel multi-tool knife with coated corkscrew, serrated blade, and bottle lifter.",
    "extendedDescriptionEn": "Modern tactical sommelier style. Finished in durable matte black PVD coating that resists scratches and delivers crisp white contrast when laser marked.",
    "specsEn": [
      "PVD Matte black coating",
      "Teflon-coated spiral corkscrew",
      "Serrated capsule knife",
      "High durability commercial build"
    ]
  },
  {
    "id": "navaja-sacacorchos-sparq",
    "name": "Navaja Sacacorchos Sparq",
    "reference": "MK-029",
    "category": "Sacacorchos y Abridores",
    "description": "Navaja fabricada en resistente acero inox, con mango ergonómico fabricado en madera natural lacada y sacacorchos integrado. La aleación de la hoja garantiza resistencia a la corrosión y abrasión, siendo ideal para el uso frecuente con materiales duros. La hoja es de tipo punta de aguja, que se caracteriza por su forma puntiaguda, con la parte superior recta.",
    "extendedDescription": "Robustez, precisión y versatilidad: las herramientas que necesitas siempre a mano. 🌲🔪🛠️ La Navaja Sacacorchos Sparq está construida para acompañarte en tus aventuras, jornadas de campo o tareas del día a día. Navaja fabricada en resistente acero inox, con mango ergonómico fabricado en madera natural lacada y sacacorchos integrado. La aleación de la hoja garantiza resistencia a la corrosión y abrasión, siendo ideal para el uso frecuente con materiales duros. La hoja es de tipo punta de aguja, que se caracteriza por su forma puntiaguda, con la parte superior recta. Madera/ Acero Inox. Herramientas en acero inoxidable de gran precisión ensambladas en una estructura ergonómica y duradera.",
    "specs": [
      "Madera/ Acero Inox",
      "Personalización exclusiva:",
      "Equípate con una compañera para toda la vida. ¡Haz tu pedido ahora!"
    ],
    "image": "/catalog/navaja-sacacorchos-sparq_1.jpg",
    "images": [
      "/catalog/navaja-sacacorchos-sparq_1.jpg",
      "/catalog/navaja-sacacorchos-sparq_2.jpg",
      "/catalog/navaja-sacacorchos-sparq_3.jpg",
      "/catalog/navaja-sacacorchos-sparq_4.jpg"
    ],
    "basePrice": 4.95,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Navaja Sacacorchos Sparq",
    "titleEn": "Sparq Classic Waiter's Knife",
    "nameEn": "Sparq Classic Waiter's Knife",
    "categoryEn": "Corkscrews & Openers",
    "descriptionEn": "Classic stainless steel waiter's friend corkscrew with natural wood inlay and dual-hinge fulcrum.",
    "extendedDescriptionEn": "The benchmark for sommeliers worldwide. Its dual-hinge fulcrum allows seamless, vertical cork removal in two effortless stages without breaking old corks.",
    "specsEn": [
      "Dual-stage articulated fulcrum",
      "Stainless steel with wood inlay",
      "Grooved non-stick spiral",
      "Serrated micro-blade cutter"
    ]
  },
  {
    "id": "sacacorchos-abridor-flomek",
    "name": "Sacacorchos Abridor Flomek",
    "reference": "MK-030",
    "category": "Sacacorchos y Abridores",
    "description": "Sacacorchos con abridor de botellas y cortacápsulas. Fabricado en combinación de de bambú y metal. Con interior en EVA troquelada.",
    "extendedDescription": "El ritual del descorche comienza con la herramienta adecuada: precisión y elegancia. 🍷👌 El Sacacorchos Abridor Flomek está pensado para abrir cada botella con total suavidad y fiabilidad. Sacacorchos con abridor de botellas y cortacápsulas. Fabricado en combinación de de bambú y metal. Con interior en EVA troquelada. Bambú.",
    "specs": [
      "Bambú",
      "Personalización exclusiva:",
      "Haz de cada descorche un momento especial. ¡Contáctanos y personalízalo!"
    ],
    "image": "/catalog/sacacorchos-abridor-flomek_1.jpg",
    "images": [
      "/catalog/sacacorchos-abridor-flomek_1.jpg",
      "/catalog/sacacorchos-abridor-flomek_2.jpg",
      "/catalog/sacacorchos-abridor-flomek_3.jpg",
      "/catalog/sacacorchos-abridor-flomek_4.jpg",
      "/catalog/sacacorchos-abridor-flomek_5.jpg"
    ],
    "basePrice": 8.95,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Sacacorchos Abridor Flomek",
    "titleEn": "Flomek Dual-Action Corkscrew",
    "nameEn": "Flomek Dual-Action Corkscrew",
    "categoryEn": "Corkscrews & Openers",
    "descriptionEn": "Ergonomic ABS body dual-action corkscrew with crown bottle opener and grooved extractor worm.",
    "extendedDescriptionEn": "Lightweight and dependable for high-volume banquets and catering. Ergonomic molded body provides optimal hand leverage with zero hand fatigue.",
    "specsEn": [
      "Reinforced impact ABS body",
      "Tempered steel extraction spiral",
      "Built-in crown cap opener",
      "Custom pad & laser printing"
    ]
  },
  {
    "id": "sacacorchos-abridor-glaber",
    "name": "Sacacorchos Abridor Glaber",
    "reference": "MK-031",
    "category": "Sacacorchos y Abridores",
    "description": "Sacacorchos de 2 tiempos fabricado en acero inox, con mango en corcho natural y cortacápsulas integrado.",
    "extendedDescription": "El ritual del descorche comienza con la herramienta adecuada: precisión y elegancia. 🍷👌 El Sacacorchos Abridor Glaber está pensado para abrir cada botella con total suavidad y fiabilidad. Sacacorchos de 2 tiempos fabricado en acero inox, con mango en corcho natural y cortacápsulas integrado. Corcho.",
    "specs": [
      "Corcho",
      "Personalización exclusiva:",
      "Haz de cada descorche un momento especial. ¡Contáctanos y personalízalo!"
    ],
    "image": "/catalog/sacacorchos-abridor-glaber_1.jpg",
    "images": [
      "/catalog/sacacorchos-abridor-glaber_1.jpg",
      "/catalog/sacacorchos-abridor-glaber_2.jpg",
      "/catalog/sacacorchos-abridor-glaber_3.jpg",
      "/catalog/sacacorchos-abridor-glaber_4.jpg"
    ],
    "basePrice": 3.55,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Sacacorchos Abridor Glaber",
    "titleEn": "Glaber Winged Corkscrew",
    "nameEn": "Glaber Winged Corkscrew",
    "categoryEn": "Corkscrews & Openers",
    "descriptionEn": "Classic winged corkscrew with self-centering collar and dual lever arms for effortless extraction.",
    "extendedDescriptionEn": "The easiest way to open wine at home. Place the bell over the bottle neck, turn the knob, and press down the two side wings for effortless cork extraction.",
    "specsEn": [
      "Sturdy cast zinc alloy",
      "Dual geared lever wings",
      "Self-centering collar",
      "Integrated top crown lifter"
    ]
  },
  {
    "id": "sacacorchos-abridor-kiblack",
    "name": "Sacacorchos Abridor Kiblack",
    "reference": "MK-032",
    "category": "Sacacorchos y Abridores",
    "description": "Sacacorchos de dos tiempos fabricado en acero inoxidable. Diseño funcional y resistente, pensado para facilitar la apertura de botellas.",
    "extendedDescription": "El ritual del descorche comienza con la herramienta adecuada: precisión y elegancia. 🍷👌 El Sacacorchos Abridor Kiblack está pensado para abrir cada botella con total suavidad y fiabilidad. Sacacorchos de dos tiempos fabricado en acero inoxidable. Diseño funcional y resistente, pensado para facilitar la apertura de botellas. Acero Inox.",
    "specs": [
      "Acero Inox",
      "Personalización exclusiva:",
      "Haz de cada descorche un momento especial. ¡Contáctanos y personalízalo!"
    ],
    "image": "/catalog/sacacorchos-abridor-kiblack_1.jpg",
    "images": [
      "/catalog/sacacorchos-abridor-kiblack_1.jpg",
      "/catalog/sacacorchos-abridor-kiblack_2.jpg",
      "/catalog/sacacorchos-abridor-kiblack_3.jpg",
      "/catalog/sacacorchos-abridor-kiblack_4.jpg",
      "/catalog/sacacorchos-abridor-kiblack_5.jpg",
      "/catalog/sacacorchos-abridor-kiblack_6.jpg"
    ],
    "basePrice": 1.2,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Sacacorchos Abridor Kiblack",
    "titleEn": "Kiblack All-Black Sommelier Corkscrew",
    "nameEn": "Kiblack All-Black Sommelier Corkscrew",
    "categoryEn": "Corkscrews & Openers",
    "descriptionEn": "Monochrome matte black dual-lever sommelier corkscrew with teflon-coated spiral.",
    "extendedDescriptionEn": "Minimalist all-black aesthetics favored by modern sommeliers. Double-step boot lever extracts natural and synthetic corks with surgical smoothness.",
    "specsEn": [
      "Matte black electrostatic finish",
      "Non-stick teflon spiral",
      "Dual-hinge lever system",
      "Serrated foil cutter blade"
    ]
  },
  {
    "id": "sacacorchos-abridor-lavip",
    "name": "Sacacorchos Abridor Lavip",
    "reference": "MK-033",
    "category": "Sacacorchos y Abridores",
    "description": "Sacacorchos con abridor de botellas y cortacápsulas. Fabricado en fibra de bambú y ABS, con accesorios en acero inox.",
    "extendedDescription": "El ritual del descorche comienza con la herramienta adecuada: precisión y elegancia. 🍷👌 El Sacacorchos Abridor Lavip está pensado para abrir cada botella con total suavidad y fiabilidad. Sacacorchos con abridor de botellas y cortacápsulas. Fabricado en fibra de bambú y ABS, con accesorios en acero inox. Fibra de Bambú/ ABS.",
    "specs": [
      "Fibra de Bambú/ ABS",
      "Personalización exclusiva:",
      "Haz de cada descorche un momento especial. ¡Contáctanos y personalízalo!"
    ],
    "image": "/catalog/sacacorchos-abridor-lavip_1.jpg",
    "images": [
      "/catalog/sacacorchos-abridor-lavip_1.jpg",
      "/catalog/sacacorchos-abridor-lavip_2.jpg",
      "/catalog/sacacorchos-abridor-lavip_3.jpg",
      "/catalog/sacacorchos-abridor-lavip_4.jpg"
    ],
    "basePrice": 2.85,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Sacacorchos Abridor Lavip",
    "titleEn": "Lavip Soft-Touch Corkscrew",
    "nameEn": "Lavip Soft-Touch Corkscrew",
    "categoryEn": "Corkscrews & Openers",
    "descriptionEn": "Soft-touch rubberized body sommelier corkscrew with chrome accents and double-action fulcrum.",
    "extendedDescriptionEn": "Velvety soft-touch finish for enhanced tactile grip. Combines polished chrome levers with an articulated boot mechanism for professional performance.",
    "specsEn": [
      "Soft-touch velvet finish",
      "Polished chrome plated steel",
      "Double-lever action",
      "Ergonomic palm curve"
    ]
  },
  {
    "id": "sacacorchos-abridor-mansen",
    "name": "Sacacorchos Abridor Mansen",
    "reference": "MK-034",
    "category": "Sacacorchos y Abridores",
    "description": "Sacacorchos fabricado en acero inox, con mango en suave madera y cortacápsulas integrado.",
    "extendedDescription": "El ritual del descorche comienza con la herramienta adecuada: precisión y elegancia. 🍷👌 El Sacacorchos Abridor Mansen está pensado para abrir cada botella con total suavidad y fiabilidad. Sacacorchos fabricado en acero inox, con mango en suave madera y cortacápsulas integrado. Madera.",
    "specs": [
      "Madera",
      "Personalización exclusiva:",
      "Haz de cada descorche un momento especial. ¡Contáctanos y personalízalo!"
    ],
    "image": "/catalog/sacacorchos-abridor-mansen_1.jpg",
    "images": [
      "/catalog/sacacorchos-abridor-mansen_1.jpg",
      "/catalog/sacacorchos-abridor-mansen_2.jpg",
      "/catalog/sacacorchos-abridor-mansen_3.jpg",
      "/catalog/sacacorchos-abridor-mansen_4.jpg",
      "/catalog/sacacorchos-abridor-mansen_5.jpg",
      "/catalog/sacacorchos-abridor-mansen_6.jpg"
    ],
    "basePrice": 4.75,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Sacacorchos Abridor Mansen",
    "titleEn": "Mansen Heavy-Duty Dual Corkscrew",
    "nameEn": "Mansen Heavy-Duty Dual Corkscrew",
    "categoryEn": "Corkscrews & Openers",
    "descriptionEn": "Heavy-duty brushed stainless steel corkscrew with solid spine and high-torque corkscrew spiral.",
    "extendedDescriptionEn": "Engineered for heavy service use. Solid brushed stainless construction provides rigid leverage that never bends, even with stubborn vintage corks.",
    "specsEn": [
      "Brushed heavy-gauge stainless steel",
      "High-torque spiral worm",
      "Dual-position articulated boot",
      "Laser engravable spine"
    ]
  },
  {
    "id": "sacacorchos-abridor-noshy",
    "name": "Sacacorchos Abridor Noshy",
    "reference": "MK-035",
    "category": "Sacacorchos y Abridores",
    "description": "Sacacorchos de 2 tiempos fabricado en acero inox, con recubrimiento exterior en cobre galvanizado. Cortacápsulas integrado.",
    "extendedDescription": "El ritual del descorche comienza con la herramienta adecuada: precisión y elegancia. 🍷👌 El Sacacorchos Abridor Noshy está pensado para abrir cada botella con total suavidad y fiabilidad. Sacacorchos de 2 tiempos fabricado en acero inox, con recubrimiento exterior en cobre galvanizado. Cortacápsulas integrado. Acero Inox.",
    "specs": [
      "Acero Inox",
      "Personalización exclusiva:",
      "Haz de cada descorche un momento especial. ¡Contáctanos y personalízalo!"
    ],
    "image": "/catalog/sacacorchos-abridor-noshy_1.jpg",
    "images": [
      "/catalog/sacacorchos-abridor-noshy_1.jpg",
      "/catalog/sacacorchos-abridor-noshy_2.jpg",
      "/catalog/sacacorchos-abridor-noshy_3.jpg",
      "/catalog/sacacorchos-abridor-noshy_4.jpg",
      "/catalog/sacacorchos-abridor-noshy_5.jpg"
    ],
    "basePrice": 3.9,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Sacacorchos Abridor Noshy",
    "titleEn": "Noshy Compact Pocket Corkscrew",
    "nameEn": "Noshy Compact Pocket Corkscrew",
    "categoryEn": "Corkscrews & Openers",
    "descriptionEn": "Sleek compact sommelier corkscrew with rounded edges and high-tensile steel extraction worm.",
    "extendedDescriptionEn": "Pocket-friendly design with smooth rounded contours. Delivers reliable performance for catering staff, restaurant teams, and home entertaining.",
    "specsEn": [
      "Ultra-compact profile",
      "High-tensile carbon steel",
      "Dual-stage lever support",
      "Micro-serrated foil knife"
    ]
  },
  {
    "id": "sacacorchos-abridor-perring",
    "name": "Sacacorchos Abridor Perring",
    "reference": "MK-036",
    "category": "Sacacorchos y Abridores",
    "description": "Original sacacorchos abridor magnético, fabricado en resistente bambú. Con sacacorchos integrado en cuerpo y sistema de apertura metálico.",
    "extendedDescription": "Diseño original, práctico e imantado: ¡siempre a mano para cuando surja el brindis! 🧲🍾 El Sacacorchos Abridor Perring combina funcionalidad y estética inteligente para tener siempre listo en tu nevera o barra. Original sacacorchos abridor magnético, fabricado en resistente bambú. Con sacacorchos integrado en cuerpo y sistema de apertura metálico. Magnético Bambú.",
    "specs": [
      "Magnético",
      "Bambú",
      "Personalización exclusiva:",
      "Haz de cada descorche un momento especial. ¡Contáctanos y personalízalo!"
    ],
    "image": "/catalog/sacacorchos-abridor-perring_1.jpg",
    "images": [
      "/catalog/sacacorchos-abridor-perring_1.jpg",
      "/catalog/sacacorchos-abridor-perring_2.jpg",
      "/catalog/sacacorchos-abridor-perring_3.jpg",
      "/catalog/sacacorchos-abridor-perring_4.jpg",
      "/catalog/sacacorchos-abridor-perring_5.jpg"
    ],
    "basePrice": 4.3,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Sacacorchos Abridor Perring",
    "titleEn": "Perring Rose Gold Waiter's Corkscrew",
    "nameEn": "Perring Rose Gold Waiter's Corkscrew",
    "categoryEn": "Corkscrews & Openers",
    "descriptionEn": "Luxury rose gold finish waiter's corkscrew with dual-stage lever and white ceramic handle inlay.",
    "extendedDescriptionEn": "Dazzling luxury aesthetic for fine dining and celebratory events. Rose gold electroplating highlights the dual-hinged mechanism and smooth handle.",
    "specsEn": [
      "Rose gold electroplated finish",
      "Ceramic-look handle inlay",
      "Dual-step fulcrum system",
      "Supplied in premium gift sleeve"
    ]
  },
  {
    "id": "sacacorchos-electrico-breya",
    "name": "Sacacorchos Eléctrico Breya",
    "reference": "MK-037",
    "category": "Sacacorchos y Abridores",
    "description": "Sacacorchos eléctrico diseñado para abrir botellas de vino de forma rápida y sencilla. Equipado con un botón de extracción automática, permite retirar el corcho sin esfuerzo,. Alimentación a pilas (4xAAA no incluidas).",
    "extendedDescription": "Abrir una botella de vino nunca fue tan rápido, cómodo y sofisticado. ⚡🍾🔋 El Sacacorchos Eléctrico Breya retira el corcho en cuestión de segundos con tan solo pulsar un botón. Sacacorchos eléctrico diseñado para abrir botellas de vino de forma rápida y sencilla. Equipado con un botón de extracción automática, permite retirar el corcho sin esfuerzo,. Alimentación a pilas (4xAAA no incluidas). 4 Pilas AAA No Incluidas. Descorcha de forma limpia y continua sin esfuerzo ni riesgo de romper el tapón.",
    "specs": [
      "4 Pilas AAA No Incluidas",
      "Personalización exclusiva:",
      "Moderniza tu ritual de vino. ¡Pregúntanos por privado y asegura el tuyo!"
    ],
    "image": "/catalog/sacacorchos-electrico-breya_1.jpg",
    "images": [
      "/catalog/sacacorchos-electrico-breya_1.jpg",
      "/catalog/sacacorchos-electrico-breya_2.jpg",
      "/catalog/sacacorchos-electrico-breya_3.jpg",
      "/catalog/sacacorchos-electrico-breya_4.jpg"
    ],
    "basePrice": 11.7,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Sacacorchos Eléctrico Breya",
    "titleEn": "Breya Electric Wine Opener",
    "nameEn": "Breya Electric Wine Opener",
    "categoryEn": "Corkscrews & Openers",
    "descriptionEn": "Rechargeable electric wine opener with LED backlight and automatic one-touch cork extraction in 6 seconds.",
    "extendedDescriptionEn": "Effortless uncorking with the press of a button. The Breya opener pulls corks automatically in under 6 seconds, illuminated by soft LED lights that indicate battery and extraction status.",
    "specsEn": [
      "Automatic one-touch operation",
      "Uncorks in 6 seconds",
      "Rechargeable lithium battery",
      "Includes integrated foil cutter"
    ]
  },
  {
    "id": "sacacorchos-electrico-deyong",
    "name": "Sacacorchos Eléctrico Deyong",
    "reference": "MK-038",
    "category": "Sacacorchos y Abridores",
    "description": "Sacacorchos eléctrico fabricado en acero inox y resistente ABS, con cortacápsulas incluido. Alimentación a pilas (4xAA no incluidas).",
    "extendedDescription": "Abrir una botella de vino nunca fue tan rápido, cómodo y sofisticado. ⚡🍾🔋 El Sacacorchos Eléctrico Deyong retira el corcho en cuestión de segundos con tan solo pulsar un botón. Sacacorchos eléctrico fabricado en acero inox y resistente ABS, con cortacápsulas incluido. Alimentación a pilas (4xAA no incluidas). 4 Pilas AA No Incluidas Acero Inox/ ABS. Descorcha de forma limpia y continua sin esfuerzo ni riesgo de romper el tapón.",
    "specs": [
      "4 Pilas AA No Incluidas",
      "Acero Inox/ ABS",
      "Personalización exclusiva:",
      "Moderniza tu ritual de vino. ¡Pregúntanos por privado y asegura el tuyo!"
    ],
    "image": "/catalog/sacacorchos-electrico-deyong_1.jpg",
    "images": [
      "/catalog/sacacorchos-electrico-deyong_1.jpg",
      "/catalog/sacacorchos-electrico-deyong_2.jpg",
      "/catalog/sacacorchos-electrico-deyong_3.jpg",
      "/catalog/sacacorchos-electrico-deyong_4.jpg",
      "/catalog/sacacorchos-electrico-deyong_5.jpg",
      "/catalog/sacacorchos-electrico-deyong_6.jpg"
    ],
    "basePrice": 17.6,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Sacacorchos Eléctrico Deyong",
    "titleEn": "Deyong Transparent Electric Opener",
    "nameEn": "Deyong Transparent Electric Opener",
    "categoryEn": "Corkscrews & Openers",
    "descriptionEn": "Electric corkscrew with transparent bottom casing, blue/red status LED lights, and USB-C fast charging.",
    "extendedDescriptionEn": "Watch the cork extraction mechanism in action through the crystal-clear lower chamber. Blue LEDs illuminate the uncorking process and red LEDs signal reverse release.",
    "specsEn": [
      "Transparent viewing chamber",
      "Dual-color LED indicators",
      "USB Type-C charging port",
      "Opens up to 80 bottles per charge"
    ]
  },
  {
    "id": "sacacorchos-electrico-rhone",
    "name": "Sacacorchos Eléctrico Rhone",
    "reference": "MK-039",
    "category": "Sacacorchos y Abridores",
    "description": "Sacacorchos eléctrico elaborado en acero inoxidable y ABS. Cuenta con botón indicador de extracción y expulsador de corcho. Con indicadores de luz durante la carga y uso. Batería recargable de 500 mAh, incluye cable de carga tipo C. Un dispositivo fácil de usar y funcional.",
    "extendedDescription": "Abrir una botella de vino nunca fue tan rápido, cómodo y sofisticado. ⚡🍾🔋 El Sacacorchos Eléctrico Rhone retira el corcho en cuestión de segundos con tan solo pulsar un botón. Sacacorchos eléctrico elaborado en acero inoxidable y ABS. Cuenta con botón indicador de extracción y expulsador de corcho. Con indicadores de luz durante la carga y uso. Batería recargable de 500 mAh, incluye cable de carga tipo C. Un dispositivo fácil de usar y funcional. Batería 500 mAh Acero Inox/ ABS. Descorcha de forma limpia y continua sin esfuerzo ni riesgo de romper el tapón.",
    "specs": [
      "Batería 500 mAh",
      "Acero Inox/ ABS",
      "Personalización exclusiva:",
      "Moderniza tu ritual de vino. ¡Pregúntanos por privado y asegura el tuyo!"
    ],
    "image": "/catalog/sacacorchos-electrico-rhone_1.jpg",
    "images": [
      "/catalog/sacacorchos-electrico-rhone_1.jpg",
      "/catalog/sacacorchos-electrico-rhone_2.jpg",
      "/catalog/sacacorchos-electrico-rhone_3.jpg",
      "/catalog/sacacorchos-electrico-rhone_4.jpg"
    ],
    "basePrice": 12.3,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Sacacorchos Eléctrico Rhone",
    "titleEn": "Rhone Executive Electric Corkscrew",
    "nameEn": "Rhone Executive Electric Corkscrew",
    "categoryEn": "Corkscrews & Openers",
    "descriptionEn": "Stainless steel body electric corkscrew with charging dock, foil cutter, vacuum stopper, and aerator pourer.",
    "extendedDescriptionEn": "The complete modern sommelier set. Features a brushed stainless steel electric corkscrew resting on a sleek desktop charging dock, accompanied by sommelier accessories.",
    "specsEn": [
      "Brushed stainless steel chassis",
      "Charging base station included",
      "Complete 4-in-1 accessory set",
      "Quiet high-torque motor"
    ]
  },
  {
    "id": "sacacorchos-greymuz",
    "name": "Sacacorchos Greymuz",
    "reference": "MK-040",
    "category": "Sacacorchos y Abridores",
    "description": "Sacacorchos con bomba de aire integrada, para una extracción del tapón de corcho fácil y segura. Fabricado en resistente material ABS y con cortacápsulas.",
    "extendedDescription": "El Sacacorchos Greymuz utiliza un sistema de bombeo de aire a presión para extraer el corcho íntegro y suavemente. Sacacorchos con bomba de aire integrada, para una extracción del tapón de corcho fácil y segura. Fabricado en resistente material ABS y con cortacápsulas.. Los acabados en madera, bambú o metal son ideales para grabado láser de alta definición: logotipos, fechas o nombres propios.",
    "specs": [
      "¿Corchos que se rompen al abrir botellas viejas? Descubre la extracción por aire. 💨🍾",
      "Personalización exclusiva:",
      "Haz de cada descorche un momento especial. ¡Contáctanos y personalízalo!"
    ],
    "image": "/catalog/sacacorchos-greymuz_1.jpg",
    "images": [
      "/catalog/sacacorchos-greymuz_1.jpg",
      "/catalog/sacacorchos-greymuz_2.jpg",
      "/catalog/sacacorchos-greymuz_3.jpg",
      "/catalog/sacacorchos-greymuz_4.jpg",
      "/catalog/sacacorchos-greymuz_5.jpg",
      "/catalog/sacacorchos-greymuz_6.jpg"
    ],
    "basePrice": 10.4,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Sacacorchos Greymuz",
    "titleEn": "Greymuz Gunmetal Sommelier Corkscrew",
    "nameEn": "Greymuz Gunmetal Sommelier Corkscrew",
    "categoryEn": "Corkscrews & Openers",
    "descriptionEn": "Gunmetal grey titanium finish dual-lever corkscrew with stainless steel grooved worm and curved handle.",
    "extendedDescriptionEn": "Sophisticated gunmetal grey titanium coating provides high scratch resistance and an understated luxury tone for sommeliers and high-end restaurant staff.",
    "specsEn": [
      "Titanium gunmetal grey finish",
      "Grooved teflon spiral",
      "Reinforced double-hinge lever",
      "Laser engraved metallic finish"
    ]
  },
  {
    "id": "sacacorchos-mac",
    "name": "Sacacorchos Mac",
    "reference": "MK-041",
    "category": "Sacacorchos y Abridores",
    "description": "Clásico sacacorchos con accesorios de acero inox. Incluye cortacápsulas y abridor.",
    "extendedDescription": "El ritual del descorche comienza con la herramienta adecuada: precisión y elegancia. 🍷👌 El Sacacorchos Mac está pensado para abrir cada botella con total suavidad y fiabilidad. Clásico sacacorchos con accesorios de acero inox. Incluye cortacápsulas y abridor..",
    "specs": [
      "Personalización exclusiva:",
      "Haz de cada descorche un momento especial. ¡Contáctanos y personalízalo!"
    ],
    "image": "/catalog/sacacorchos-mac_1.jpg",
    "images": [
      "/catalog/sacacorchos-mac_1.jpg",
      "/catalog/sacacorchos-mac_2.jpg",
      "/catalog/sacacorchos-mac_3.jpg",
      "/catalog/sacacorchos-mac_4.jpg",
      "/catalog/sacacorchos-mac_5.jpg",
      "/catalog/sacacorchos-mac_6.jpg"
    ],
    "basePrice": 1.6,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Sacacorchos Mac",
    "titleEn": "Mac Natural Wood Sommelier Corkscrew",
    "nameEn": "Mac Natural Wood Sommelier Corkscrew",
    "categoryEn": "Corkscrews & Openers",
    "descriptionEn": "Natural solid beechwood handle waiter's corkscrew with double-step articulated lever and foil cutter.",
    "extendedDescriptionEn": "Warm organic wood aesthetic combined with the precision of a dual-action sommelier tool. The solid beechwood handle feels substantial and comfortable in the palm.",
    "specsEn": [
      "Solid natural beechwood handle",
      "Brushed stainless steel levers",
      "Dual-stage extraction boot",
      "Optimal laser burning contrast"
    ]
  },
  {
    "id": "sacacorchos-nolix",
    "name": "Sacacorchos Nolix",
    "reference": "MK-042",
    "category": "Sacacorchos y Abridores",
    "description": "Divertido sacacorchos magnético con forma de botella de vino en diseños blanco, tinto y rosado. Con cuerpo en original acabado translúcido y función abridor.",
    "extendedDescription": "Diseño original, práctico e imantado: ¡siempre a mano para cuando surja el brindis! 🧲🍾 El Sacacorchos Nolix combina funcionalidad y estética inteligente para tener siempre listo en tu nevera o barra. Divertido sacacorchos magnético con forma de botella de vino en diseños blanco, tinto y rosado. Con cuerpo en original acabado translúcido y función abridor. Magnético.",
    "specs": [
      "Magnético",
      "Personalización exclusiva:",
      "Haz de cada descorche un momento especial. ¡Contáctanos y personalízalo!"
    ],
    "image": "/catalog/sacacorchos-nolix_1.jpg",
    "images": [
      "/catalog/sacacorchos-nolix_1.jpg",
      "/catalog/sacacorchos-nolix_2.jpg",
      "/catalog/sacacorchos-nolix_3.jpg",
      "/catalog/sacacorchos-nolix_4.jpg",
      "/catalog/sacacorchos-nolix_5.jpg",
      "/catalog/sacacorchos-nolix_6.jpg"
    ],
    "basePrice": 1.4,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Sacacorchos Nolix",
    "titleEn": "Nolix Lever Arm Desktop Corkscrew",
    "nameEn": "Nolix Lever Arm Desktop Corkscrew",
    "categoryEn": "Corkscrews & Openers",
    "descriptionEn": "Vertical lever-action rabbit corkscrew with heavy zinc alloy clamp for rapid cork removal in 3 seconds.",
    "extendedDescriptionEn": "The fastest manual uncorking mechanism available. Simply clamp onto the bottle neck and pull the lever down and up; the cork is pulled and ejected in 3 seconds flat.",
    "specsEn": [
      "Rapid vertical lever mechanism",
      "Heavy-gauge die-cast zinc alloy",
      "Extracts cork in 3 seconds",
      "Includes magnetic foil trimmer"
    ]
  },
  {
    "id": "sacacorchos-parples",
    "name": "Sacacorchos Parples",
    "reference": "MK-043",
    "category": "Sacacorchos y Abridores",
    "description": "Sacacorchos con bomba de aire integrada, para una extracción del tapón de corcho fácil y segura. Fabricado en resistente material ABS.",
    "extendedDescription": "El Sacacorchos Parples utiliza un sistema de bombeo de aire a presión para extraer el corcho íntegro y suavemente. Sacacorchos con bomba de aire integrada, para una extracción del tapón de corcho fácil y segura. Fabricado en resistente material ABS.. Los acabados en madera, bambú o metal son ideales para grabado láser de alta definición: logotipos, fechas o nombres propios.",
    "specs": [
      "¿Corchos que se rompen al abrir botellas viejas? Descubre la extracción por aire. 💨🍾",
      "Personalización exclusiva:",
      "Haz de cada descorche un momento especial. ¡Contáctanos y personalízalo!"
    ],
    "image": "/catalog/sacacorchos-parples_1.jpg",
    "images": [
      "/catalog/sacacorchos-parples_1.jpg",
      "/catalog/sacacorchos-parples_2.jpg",
      "/catalog/sacacorchos-parples_3.jpg",
      "/catalog/sacacorchos-parples_4.jpg"
    ],
    "basePrice": 4.3,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Sacacorchos Parples",
    "titleEn": "Parples Soft-Grip Waiter's Friend",
    "nameEn": "Parples Soft-Grip Waiter's Friend",
    "categoryEn": "Corkscrews & Openers",
    "descriptionEn": "Ergonomic two-tone sommelier corkscrew with textured soft-rubber handle grip and double-step lever.",
    "extendedDescriptionEn": "Designed for long catering shifts. The dual-material handle dampens pressure points while the 5-turn grooved spiral prevents cork crumbling.",
    "specsEn": [
      "Dual-injection soft rubber grip",
      "Dual-position boot lever",
      "5-Turn grooved corkscrew",
      "Serrated foil cutter blade"
    ]
  },
  {
    "id": "sacacorchos-soporte-kofko",
    "name": "Sacacorchos Soporte Kofko",
    "reference": "MK-044",
    "category": "Sacacorchos y Abridores",
    "description": "Práctico sacacorchos con función de soporte para botellas fabricado en bambú. Con troquelado redondo para apoyar la botella y sacacorchos extraíble en acero inoxidable fijado con imanes.",
    "extendedDescription": "El ritual del descorche comienza con la herramienta adecuada: precisión y elegancia. 🍷👌 El Sacacorchos Soporte Kofko está pensado para abrir cada botella con total suavidad y fiabilidad. Práctico sacacorchos con función de soporte para botellas fabricado en bambú. Con troquelado redondo para apoyar la botella y sacacorchos extraíble en acero inoxidable fijado con imanes. Bambú.",
    "specs": [
      "Bambú",
      "Personalización exclusiva:",
      "Haz de cada descorche un momento especial. ¡Contáctanos y personalízalo!"
    ],
    "image": "/catalog/sacacorchos-soporte-kofko_1.jpg",
    "images": [
      "/catalog/sacacorchos-soporte-kofko_1.jpg",
      "/catalog/sacacorchos-soporte-kofko_2.jpg",
      "/catalog/sacacorchos-soporte-kofko_3.jpg",
      "/catalog/sacacorchos-soporte-kofko_4.jpg"
    ],
    "basePrice": 3.6,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Sacacorchos Soporte Kofko",
    "titleEn": "Kofko Tabletop Corkscrew with Stand",
    "nameEn": "Kofko Tabletop Corkscrew with Stand",
    "categoryEn": "Corkscrews & Openers",
    "descriptionEn": "Professional lever corkscrew mounted on a natural bamboo display stand with matching foil cutter.",
    "extendedDescriptionEn": "A statement piece for wine bars and home cellars. The high-performance lever corkscrew rests upright on a handsome solid bamboo presentation base.",
    "specsEn": [
      "Solid bamboo presentation base",
      "Heavy-duty lever mechanism",
      "Matching bamboo foil cutter",
      "Ideal VIP executive gift"
    ]
  },
  {
    "id": "sacacorchos-zydris",
    "name": "Sacacorchos Zydris",
    "reference": "MK-045",
    "category": "Sacacorchos y Abridores",
    "description": "Original sacacorchos con innovador mecanismo de extracción sin perforar el corcho, evitando la contaminación del vino o de cualquier otro líquido contenido en la botella. Fabricado en resistente acero inox, con funda en ABS de elegante color negro.",
    "extendedDescription": "El secreto de los coleccionistas: abre tus vinos más preciados sin perforar el corcho. ⏳🍷 El Sacacorchos Zydris de dos láminas extrae el tapón sin perforarlo, preservando el vino sin restos de corcho. Original sacacorchos con innovador mecanismo de extracción sin perforar el corcho, evitando la contaminación del vino o de cualquier otro líquido contenido en la botella. Fabricado en resistente acero inox, con funda en ABS de elegante color negro. Metal/ ABS.",
    "specs": [
      "Metal/ ABS",
      "Personalización exclusiva:",
      "Haz de cada descorche un momento especial. ¡Contáctanos y personalízalo!"
    ],
    "image": "/catalog/sacacorchos-zydris_1.jpg",
    "images": [
      "/catalog/sacacorchos-zydris_1.jpg",
      "/catalog/sacacorchos-zydris_2.jpg",
      "/catalog/sacacorchos-zydris_3.jpg",
      "/catalog/sacacorchos-zydris_4.jpg",
      "/catalog/sacacorchos-zydris_5.jpg",
      "/catalog/sacacorchos-zydris_6.jpg"
    ],
    "basePrice": 4.2,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Sacacorchos Zydris",
    "titleEn": "Zydris Stainless Steel Slim Corkscrew",
    "nameEn": "Zydris Stainless Steel Slim Corkscrew",
    "categoryEn": "Corkscrews & Openers",
    "descriptionEn": "Ultra-slim 100% polished stainless steel sommelier corkscrew with integrated capsule cutter and bottle opener.",
    "extendedDescriptionEn": "Pure stainless steel minimalism. Engineered with zero plastic parts for a lifetime of dependable uncorking at vineyard tastings and cellar events.",
    "specsEn": [
      "100% High-grade stainless steel",
      "Monobloc slim silhouette",
      "Dual-pivot fulcrum",
      "Sleek mirror-polished finish"
    ]
  },
  {
    "id": "set-cubiertos-vintar",
    "name": "Set Cubiertos Vintar",
    "reference": "MK-046",
    "category": "Estuches y Sets",
    "description": "Set de cubiertos multifuncional fabricado en acero inoxidable y bambú. Incluye 7 funciones: cuchara, tenedor, cuchillo, abrebotellas, abrelatas, sacacorchos y punzón.",
    "extendedDescription": "Comer y brindar donde te lleve el camino: 7 funciones en un diseño compacto y natural. 🏕️🍴🍷 El Set Cubiertos Vintar es el kit gastronómico de bolsillo definitivo para picnics, escapadas y viajes. Set de cubiertos multifuncional fabricado en acero inoxidable y bambú. Incluye 7 funciones: cuchara, tenedor, cuchillo, abrebotellas, abrelatas, sacacorchos y punzón. 7 Funciones Bambú/ Acero Inox. Fabricado con la combinación perfecta de acero inoxidable y madera de bambú.",
    "specs": [
      "7 Funciones",
      "Bambú/ Acero Inox",
      "Personalización exclusiva:",
      "Prepárate para disfrutar de la buena mesa en cualquier lugar. ¡Pídelo ya!"
    ],
    "image": "/catalog/set-cubiertos-vintar_1.jpg",
    "images": [
      "/catalog/set-cubiertos-vintar_1.jpg",
      "/catalog/set-cubiertos-vintar_2.jpg",
      "/catalog/set-cubiertos-vintar_3.jpg",
      "/catalog/set-cubiertos-vintar_4.jpg",
      "/catalog/set-cubiertos-vintar_5.jpg"
    ],
    "basePrice": 5.4,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Set Cubiertos Vintar",
    "titleEn": "Vintar Sommelier Cheese & Wine Set",
    "nameEn": "Vintar Sommelier Cheese & Wine Set",
    "categoryEn": "Cases & Gift Sets",
    "descriptionEn": "4-Piece stainless steel cheese cutlery and sommelier set in a book-style magnetic closing gift box.",
    "extendedDescriptionEn": "The ultimate pairing for wine and cheese tastings. Includes hard and soft cheese knives, serving fork, and sommelier corkscrew presented in a luxury book-shaped case.",
    "specsEn": [
      "4 Stainless steel tools",
      "Ergonomic wooden handle inlays",
      "Magnetic closure presentation book",
      "Laser engraved blades & box"
    ]
  },
  {
    "id": "set-prescot",
    "name": "Set Prescot",
    "reference": "MK-047",
    "category": "Estuches y Sets",
    "description": "Elegante set de vinos fabricado en cristal, con delicado e innovador recubrimiento rosado degradado. Un regalo de diseño que incluye 4 vasos de 500 ml y un decantador de 1,8 l.",
    "extendedDescription": "El deslumbrante glamour del cristal con tono rosado degradado en tu mesa. 🌸🥂✨ El Set Prescot es una auténtica joya de cristalería diseñada para los brindis más memorables. Elegante set de vinos fabricado en cristal, con delicado e innovador recubrimiento rosado degradado. Un regalo de diseño que incluye 4 vasos de 500 ml y un decantador de 1,8 l. 4 Vasos 500 ml. Decantador 1,8 L Cristal. Su acabado en rosa degradado captura la luz creando una atmósfera elegante y festiva.",
    "specs": [
      "4 Vasos 500 ml. Decantador 1,8 L",
      "Cristal",
      "Personalización exclusiva:",
      "Haz que cada brindis sea inolvidable. ¡Consúltanos y resérvalo!"
    ],
    "image": "/catalog/set-prescot_1.jpg",
    "images": [
      "/catalog/set-prescot_1.jpg",
      "/catalog/set-prescot_2.jpg",
      "/catalog/set-prescot_3.jpg",
      "/catalog/set-prescot_4.jpg",
      "/catalog/set-prescot_5.jpg",
      "/catalog/set-prescot_6.jpg"
    ],
    "basePrice": 25.7,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Set Prescot",
    "titleEn": "Prescot Executive Wine Gift Box",
    "nameEn": "Prescot Executive Wine Gift Box",
    "categoryEn": "Cases & Gift Sets",
    "descriptionEn": "4-Piece executive wine accessories set housed in a round bamboo case with magnetic lid.",
    "extendedDescriptionEn": "Round sustainable bamboo case housing a stainless steel corkscrew, aerator pourer, drip stop ring, and wine bottle stopper, securely set in high-density foam.",
    "specsEn": [
      "100% Natural bamboo case",
      "Magnetic lid closure",
      "4 High-grade stainless accessories",
      "Large laser engraving surface"
    ]
  },
  {
    "id": "set-vinos-albion",
    "name": "Set Vinos Albion",
    "reference": "MK-048",
    "category": "Estuches y Sets",
    "description": "Set de vinos de elegante diseño circular acabado en polipiel, con accesorios de acero inox. Incluye sacacorchos de 2 tiempos con cortacápsulas y abridor; tapón, dosificador y recogegotas.",
    "extendedDescription": "La experiencia completa de un sumiller reunida en un estuche de lujo. 🍷🪵✨ El Set Vinos Albion contiene las herramientas clave para disfrutar del vino como un verdadero experto. Set de vinos de elegante diseño circular acabado en polipiel, con accesorios de acero inox. Incluye sacacorchos de 2 tiempos con cortacápsulas y abridor; tapón, dosificador y recogegotas. 4 Accesorios.",
    "specs": [
      "4 Accesorios",
      "Personalización exclusiva:",
      "Regala o regálate una pieza de distinción. ¡Escríbenos y consulta detalles!"
    ],
    "image": "/catalog/set-vinos-albion_1.jpg",
    "images": [
      "/catalog/set-vinos-albion_1.jpg",
      "/catalog/set-vinos-albion_2.jpg",
      "/catalog/set-vinos-albion_3.jpg",
      "/catalog/set-vinos-albion_4.jpg",
      "/catalog/set-vinos-albion_5.jpg"
    ],
    "basePrice": 13.8,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Set Vinos Albion",
    "titleEn": "Albion 4-Piece Wine Set in Bamboo Case",
    "nameEn": "Albion 4-Piece Wine Set in Bamboo Case",
    "categoryEn": "Cases & Gift Sets",
    "descriptionEn": "Square bamboo presentation box with sommelier corkscrew, thermometer, drip ring, and alloy stopper.",
    "extendedDescriptionEn": "A comprehensive wine service set for connoisseurs. Measures cellar temperature, aerates, uncorks, and preserves unfinished bottles inside a solid bamboo chest.",
    "specsEn": [
      "Solid bamboo case with metal latch",
      "Includes precision wine thermometer",
      "Dual-lever bamboo corkscrew",
      "Bottle stopper & drip collar"
    ]
  },
  {
    "id": "set-vinos-baco",
    "name": "Set Vinos Baco",
    "reference": "MK-049",
    "category": "Estuches y Sets",
    "description": "Set de vinos de elegante diseño circular con acabado en madera natural. Accesorios de acero inox y madera. Incluye sacacorchos con cortacápsulas y abridor, tapón, dosificador, recogegotas y termómetro. Presentado en estuche individual con interior en suave espuma troquelada de color beige.",
    "extendedDescription": "La experiencia completa de un sumiller reunida en un estuche de lujo. 🍷🪵✨ El Set Vinos Baco contiene las herramientas clave para disfrutar del vino como un verdadero experto. Set de vinos de elegante diseño circular con acabado en madera natural. Accesorios de acero inox y madera. Incluye sacacorchos con cortacápsulas y abridor, tapón, dosificador, recogegotas y termómetro. Presentado en estuche individual con interior en suave espuma troquelada de color beige. 5 Accesorios Madera.",
    "specs": [
      "5 Accesorios",
      "Madera",
      "Personalización exclusiva:",
      "Regala o regálate una pieza de distinción. ¡Escríbenos y consulta detalles!"
    ],
    "image": "/catalog/set-vinos-baco_1.jpg",
    "images": [
      "/catalog/set-vinos-baco_1.jpg",
      "/catalog/set-vinos-baco_2.jpg",
      "/catalog/set-vinos-baco_3.jpg",
      "/catalog/set-vinos-baco_4.jpg",
      "/catalog/set-vinos-baco_5.jpg"
    ],
    "basePrice": 19.5,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Set Vinos Baco",
    "titleEn": "Baco Bottle-Shaped Wine Tool Set",
    "nameEn": "Baco Bottle-Shaped Wine Tool Set",
    "categoryEn": "Cases & Gift Sets",
    "descriptionEn": "Creative 3-piece wine tool set housed inside a realistic miniature wine bottle with magnetic latch.",
    "extendedDescriptionEn": "Clever and eye-catching. The magnetic miniature wine bottle case opens to reveal a stainless sommelier corkscrew, drip ring, and wine pourer.",
    "specsEn": [
      "Miniature wine bottle silhouette",
      "Magnetic snap closure",
      "3 Stainless steel essential tools",
      "Full-color body label branding"
    ]
  },
  {
    "id": "set-vinos-boriax",
    "name": "Set Vinos Boriax",
    "reference": "MK-050",
    "category": "Estuches y Sets",
    "description": "Set de vino con acabado en madera de bambú y accesorios de acero inoxidable. Incluye sacacorchos, cortacápsulas, tapón, dosificador y recogegotas.",
    "extendedDescription": "La experiencia completa de un sumiller reunida en un estuche de lujo. 🍷🪵✨ El Set Vinos Boriax contiene las herramientas clave para disfrutar del vino como un verdadero experto. Set de vino con acabado en madera de bambú y accesorios de acero inoxidable. Incluye sacacorchos, cortacápsulas, tapón, dosificador y recogegotas. 4 Accesorios Bambú.",
    "specs": [
      "4 Accesorios",
      "Bambú",
      "Personalización exclusiva:",
      "Regala o regálate una pieza de distinción. ¡Escríbenos y consulta detalles!"
    ],
    "image": "/catalog/set-vinos-boriax_1.jpg",
    "images": [
      "/catalog/set-vinos-boriax_1.jpg",
      "/catalog/set-vinos-boriax_2.jpg",
      "/catalog/set-vinos-boriax_3.jpg",
      "/catalog/set-vinos-boriax_4.jpg"
    ],
    "basePrice": 20.8,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Set Vinos Boriax",
    "titleEn": "Boriax Luxury Wooden Wine Chest",
    "nameEn": "Boriax Luxury Wooden Wine Chest",
    "categoryEn": "Cases & Gift Sets",
    "descriptionEn": "Handcrafted dark cherry wood chest containing sommelier lever opener, vacuum pump, stoppers, and cutter.",
    "extendedDescriptionEn": "Aristocratic presentation for premier crus. Richly lacquered cherry wood case with brass hinges, housing professional sommelier tools in velvet-lined recesses.",
    "specsEn": [
      "Lacquered cherry wood chest",
      "Heavy lever-action uncorker",
      "Vacuum pump with 2 stoppers",
      "Foil cutter & replacement worm"
    ]
  },
  {
    "id": "set-vinos-bribal",
    "name": "Set Vinos Bribal",
    "reference": "MK-051",
    "category": "Estuches y Sets",
    "description": "Set de vinos de elegante diseño circular con acabado en corcho natural. Accesorios de acero inox, incluye sacacorchos de 2 tiempos con cortacápsulas y abridor, tapón, dosificador y recogegotas",
    "extendedDescription": "La experiencia completa de un sumiller reunida en un estuche de lujo. 🍷🪵✨ El Set Vinos Bribal contiene las herramientas clave para disfrutar del vino como un verdadero experto. Set de vinos de elegante diseño circular con acabado en corcho natural. Accesorios de acero inox, incluye sacacorchos de 2 tiempos con cortacápsulas y abridor, tapón, dosificador y recogegotas 4 Accesorios Corcho.",
    "specs": [
      "4 Accesorios",
      "Corcho",
      "Personalización exclusiva:",
      "Regala o regálate una pieza de distinción. ¡Escríbenos y consulta detalles!"
    ],
    "image": "/catalog/set-vinos-bribal_1.jpg",
    "images": [
      "/catalog/set-vinos-bribal_1.jpg",
      "/catalog/set-vinos-bribal_2.jpg",
      "/catalog/set-vinos-bribal_3.jpg",
      "/catalog/set-vinos-bribal_4.jpg"
    ],
    "basePrice": 10.5,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Set Vinos Bribal",
    "titleEn": "Bribal Barrel-Shaped Wine Set",
    "nameEn": "Bribal Barrel-Shaped Wine Set",
    "categoryEn": "Cases & Gift Sets",
    "descriptionEn": "Oak barrel replica gift box with 4 stainless sommelier tools: corkscrew, stopper, collar, and cutter.",
    "extendedDescriptionEn": "Miniature oak barrel that opens with magnetic latches. A delightful nod to cooperage tradition that will charm any wine lover or vineyard visitor.",
    "specsEn": [
      "Miniature rustic barrel design",
      "Magnetic split-open latch",
      "4 Polished stainless tools",
      "Custom UV laser engraved lid"
    ]
  },
  {
    "id": "set-vinos-darini",
    "name": "Set Vinos Darini",
    "reference": "MK-052",
    "category": "Estuches y Sets",
    "description": "Set de vinos presentado en un diseño inspirado en botella de vino y tallado en bambú, con accesorios en acero inox. Incluye sacacorchos de 2 tiempos con cortacápsulas y abridor; tapón, dosificador y recogegotas.",
    "extendedDescription": "La experiencia completa de un sumiller reunida en un estuche de lujo. 🍷🪵✨ El Set Vinos Darini contiene las herramientas clave para disfrutar del vino como un verdadero experto. Set de vinos presentado en un diseño inspirado en botella de vino y tallado en bambú, con accesorios en acero inox. Incluye sacacorchos de 2 tiempos con cortacápsulas y abridor; tapón, dosificador y recogegotas. 4 Accesorios Bambú.",
    "specs": [
      "4 Accesorios",
      "Bambú",
      "Personalización exclusiva:",
      "Regala o regálate una pieza de distinción. ¡Escríbenos y consulta detalles!"
    ],
    "image": "/catalog/set-vinos-darini_1.jpg",
    "images": [
      "/catalog/set-vinos-darini_1.jpg",
      "/catalog/set-vinos-darini_2.jpg",
      "/catalog/set-vinos-darini_3.jpg",
      "/catalog/set-vinos-darini_4.jpg",
      "/catalog/set-vinos-darini_5.jpg"
    ],
    "basePrice": 12.8,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Set Vinos Darini",
    "titleEn": "Darini 5-Piece Sommelier Case",
    "nameEn": "Darini 5-Piece Sommelier Case",
    "categoryEn": "Cases & Gift Sets",
    "descriptionEn": "Faux-leather presentation box with contrast white stitching, housing 5 sommelier tools for complete wine service.",
    "extendedDescriptionEn": "Classic executive elegance. Black textured leatherette box with magnetic flip top, containing waiter's corkscrew, aerator, thermometer, stopper, and collar.",
    "specsEn": [
      "Black leatherette case with white stitching",
      "5 Professional wine accessories",
      "High-density protective EVA lining",
      "Elegant corporate gift"
    ]
  },
  {
    "id": "set-vinos-neider",
    "name": "Set vinos Neider",
    "reference": "MK-053",
    "category": "Estuches y Sets",
    "description": "Set de vinos en elegante estuche de bambú con interior troquelado en espuma. Incluye 2 copas de cristal de 350 ml y sacacorchos de 2 tiempos en acero inox, con cortacápsulas.",
    "extendedDescription": "2 copas de cristal y los mejores accesorios en un elegante estuche de bambú. 🥂✨🎋 El Set vinos Neider está pensado para celebrar brindis únicos en la mejor compañía. Set de vinos en elegante estuche de bambú con interior troquelado en espuma. Incluye 2 copas de cristal de 350 ml y sacacorchos de 2 tiempos en acero inox, con cortacápsulas. 2 Copas Cristal 350 ml. Sacacorchos Abridor Acero Inox Bambú.",
    "specs": [
      "2 Copas Cristal 350 ml. Sacacorchos Abridor Acero Inox",
      "Bambú",
      "Personalización exclusiva:",
      "Regala o regálate una pieza de distinción. ¡Escríbenos y consulta detalles!"
    ],
    "image": "/catalog/set-vinos-neider_1.jpg",
    "images": [
      "/catalog/set-vinos-neider_1.jpg",
      "/catalog/set-vinos-neider_2.jpg",
      "/catalog/set-vinos-neider_3.jpg",
      "/catalog/set-vinos-neider_4.jpg",
      "/catalog/set-vinos-neider_5.jpg",
      "/catalog/set-vinos-neider_6.jpg"
    ],
    "basePrice": 32.8,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Set vinos Neider",
    "titleEn": "Neider Modern Wine Gift Set",
    "nameEn": "Neider Modern Wine Gift Set",
    "categoryEn": "Cases & Gift Sets",
    "descriptionEn": "Compact matte black presentation box with dual-stage waiter's corkscrew, stainless pourer, and leak-proof stopper.",
    "extendedDescriptionEn": "Essential sommelier trio in a sleek gift box. Features a heavy-duty dual-hinge corkscrew, silicone-sealed wine stopper, and drip-free aerator spout.",
    "specsEn": [
      "Compact matte black presentation box",
      "Dual-stage waiter's friend",
      "Silicone sealed bottle stopper",
      "Drip-free aerator pourer"
    ]
  },
  {
    "id": "set-vinos-nitol",
    "name": "Set Vinos Nitol",
    "reference": "MK-054",
    "category": "Estuches y Sets",
    "description": "Set de vinos acabado en madera bambú. Accesorios de acero inox. Incluye sacacorchos, dosificador y recogegotas.",
    "extendedDescription": "La experiencia completa de un sumiller reunida en un estuche de lujo. 🍷🪵✨ El Set Vinos Nitol contiene las herramientas clave para disfrutar del vino como un verdadero experto. Set de vinos acabado en madera bambú. Accesorios de acero inox. Incluye sacacorchos, dosificador y recogegotas. 3 Accesorios Bambú.",
    "specs": [
      "3 Accesorios",
      "Bambú",
      "Personalización exclusiva:",
      "Regala o regálate una pieza de distinción. ¡Escríbenos y consulta detalles!"
    ],
    "image": "/catalog/set-vinos-nitol_1.jpg",
    "images": [
      "/catalog/set-vinos-nitol_1.jpg",
      "/catalog/set-vinos-nitol_2.jpg",
      "/catalog/set-vinos-nitol_3.jpg",
      "/catalog/set-vinos-nitol_4.jpg"
    ],
    "basePrice": 9.8,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Set Vinos Nitol",
    "titleEn": "Nitol Bamboo 2-Piece Wine Set",
    "nameEn": "Nitol Bamboo 2-Piece Wine Set",
    "categoryEn": "Cases & Gift Sets",
    "descriptionEn": "Eco-friendly bamboo case containing a bamboo waiter's corkscrew and matching bamboo-headed stopper.",
    "extendedDescriptionEn": "Sustainable simplicity. Natural bamboo box holding two indispensable wine tools crafted with renewable bamboo accents for a clean, organic look.",
    "specsEn": [
      "100% Renewable bamboo box",
      "Bamboo waiter's corkscrew",
      "Bamboo & stainless wine stopper",
      "Perfect for green winery branding"
    ]
  },
  {
    "id": "set-vinos-paluk",
    "name": "Set Vinos Paluk",
    "reference": "MK-055",
    "category": "Estuches y Sets",
    "description": "Original set de vinos ajedrez -piezas incluidas- acabado en bambú natural. Con cierre de seguridad y accesorios de acero inox y bambú. Incluye sacacorchos con cortacápsulas y abridor; tapón, decantador y recogegotas.",
    "extendedDescription": "El Set Vinos Paluk une la pasión por el buen vino con el encanto del ajedrez tradicional. Original set de vinos ajedrez -piezas incluidas- acabado en bambú natural. Con cierre de seguridad y accesorios de acero inox y bambú. Incluye sacacorchos con cortacápsulas y abridor; tapón, decantador y recogegotas. 4 Accesorios Bambú. Personalizamos a láser la tapa del estuche con nombres de novios, dedicatorias de jubilación, aniversarios o el logo de tu empresa.",
    "specs": [
      "4 Accesorios",
      "Bambú",
      "¿Vino y ajedrez? La combinación maestra para veladas de conversación y estrategia. ♟️🍷🪵",
      "Personalización exclusiva:",
      "Regala o regálate una pieza de distinción. ¡Escríbenos y consulta detalles!"
    ],
    "image": "/catalog/set-vinos-paluk_1.jpg",
    "images": [
      "/catalog/set-vinos-paluk_1.jpg",
      "/catalog/set-vinos-paluk_2.jpg",
      "/catalog/set-vinos-paluk_3.jpg",
      "/catalog/set-vinos-paluk_4.jpg",
      "/catalog/set-vinos-paluk_5.jpg",
      "/catalog/set-vinos-paluk_6.jpg"
    ],
    "basePrice": 19.6,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Set Vinos Paluk",
    "titleEn": "Paluk 4-Piece Sommelier Kit",
    "nameEn": "Paluk 4-Piece Sommelier Kit",
    "categoryEn": "Cases & Gift Sets",
    "descriptionEn": "Textured carbon-look hard case with zip closure, holding waiter's corkscrew, foil cutter, stopper, and pourer.",
    "extendedDescriptionEn": "Travel-ready sommelier kit in a rigid zippered travel case. Keeps tools tightly organized and protected for mobile tastings, picnics, and vineyard tours.",
    "specsEn": [
      "Shockproof carbon-look zipper case",
      "Elastic tool retention straps",
      "4 Professional stainless accessories",
      "Travel & picnic friendly"
    ]
  },
  {
    "id": "tapon-abridor-pomni",
    "name": "Tapón Abridor Pomni",
    "reference": "MK-056",
    "category": "Sacacorchos y Abridores",
    "description": "Práctico tapón para botellas con abridor integrado. Fabricado en bambú y acero inox. Incluye aros de silicona en el tapón para un ajuste perfecto al cuello de la botella.",
    "extendedDescription": "El Tapón Abridor Pomni aúna conservación hermética y abrebotellas en un diseño compacto. Práctico tapón para botellas con abridor integrado. Fabricado en bambú y acero inox. Incluye aros de silicona en el tapón para un ajuste perfecto al cuello de la botella. Bambú. Disponible en formato redondo y cuadrado. Personalizable a láser con iniciales, logos de bodegas o fechas especiales.",
    "specs": [
      "Bambú.",
      "Disponible en formato redondo y cuadrado",
      "¿Tapón hermético y abridor en una sola pieza? La comodidad inteligente del bambú. 🍾👌🎋",
      "Personalización exclusiva:",
      "Disfruta de cada copa a tu propio ritmo. ¡Haz tu pedido ahora!"
    ],
    "image": "/catalog/tapon-abridor-pomni_1.jpg",
    "images": [
      "/catalog/tapon-abridor-pomni_1.jpg",
      "/catalog/tapon-abridor-pomni_2.jpg",
      "/catalog/tapon-abridor-pomni_3.jpg",
      "/catalog/tapon-abridor-pomni_4.jpg",
      "/catalog/tapon-abridor-pomni_5.jpg",
      "/catalog/tapon-abridor-pomni_6.jpg"
    ],
    "basePrice": 2.7,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Tapón Abridor Pomni",
    "titleEn": "Pomni 2-in-1 Stopper & Cap Opener",
    "nameEn": "Pomni 2-in-1 Stopper & Cap Opener",
    "categoryEn": "Corkscrews & Openers",
    "descriptionEn": "Dual-purpose stainless steel accessory combining an airtight silicone wine stopper with a crown bottle opener.",
    "extendedDescriptionEn": "Ingenious dual utility. Seals opened wine bottles with a multi-ring silicone gasket while offering an integrated lever to uncap beer, cider, and craft sodas.",
    "specsEn": [
      "Food-grade silicone seal rings",
      "Heavy-gauge stainless steel opener",
      "Preserves opened bottle freshness",
      "Flat profile for custom logo engraving"
    ]
  },
  {
    "id": "tapon-bomba-vacio-hoxmar",
    "name": "Tapón Bomba Vacio Hoxmar",
    "reference": "MK-057",
    "category": "Accesorios de Sumiller",
    "description": "Tapón con bomba de vacío para botellas de vino en elegante diseño de color negro. Parte superior del tapón para marcaje en tampografía.",
    "extendedDescription": "El Tapón Bomba Vacio Hoxmar aúna conservación hermética y abrebotellas en un diseño compacto. Tapón con bomba de vacío para botellas de vino en elegante diseño de color negro. Parte superior del tapón para marcaje en tampografía. ABS. Personalizable a láser con iniciales, logos de bodegas o fechas especiales.",
    "specs": [
      "ABS",
      "¿Tapón hermético y abridor en una sola pieza? La comodidad inteligente del bambú. 🍾👌🎋",
      "Personalización exclusiva:",
      "Disfruta de cada copa a tu propio ritmo. ¡Haz tu pedido ahora!"
    ],
    "image": "/catalog/tapon-bomba-vacio-hoxmar_1.jpg",
    "images": [
      "/catalog/tapon-bomba-vacio-hoxmar_1.jpg",
      "/catalog/tapon-bomba-vacio-hoxmar_2.jpg",
      "/catalog/tapon-bomba-vacio-hoxmar_3.jpg",
      "/catalog/tapon-bomba-vacio-hoxmar_4.jpg"
    ],
    "basePrice": 2.4,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Tapón Bomba Vacio Hoxmar",
    "titleEn": "Hoxmar Vacuum Wine Stopper",
    "nameEn": "Hoxmar Vacuum Wine Stopper",
    "categoryEn": "Sommelier Accessories",
    "descriptionEn": "Integrated manual vacuum pump stopper with date dial, expelling air to preserve opened wine up to 10 days.",
    "extendedDescriptionEn": "Pump the top piston repeatedly to extract air and create a vacuum seal inside the bottle. Rotate the top dial to record the bottle opening date.",
    "specsEn": [
      "Built-in vacuum extraction pump",
      "Date marking memory ring",
      "Extends wine life up to 10 days",
      "Airtight food-grade silicone core"
    ]
  },
  {
    "id": "bolsa-conservadora-de-frio-para-botella-de-vino-cata",
    "name": "Bolsa Conservadora De Frio Para Botella De Vino “Cata”",
    "reference": "CF-001",
    "category": "Bolsas y Enfriadores",
    "description": "Soporte de alta gama para vino y sumillería con acabado optimizado para personalización láser UV.",
    "extendedDescription": "El vino siempre a su temperatura ideal, ¡incluso en los días más calurosos! ❄️🍾 Nuestra Bolsa Conservadora de Frío 'Cata' está diseñada para mantener tus botellas frescas durante horas. Confeccionada con material aislante reforzado, líquido refrigerante interior y asas de transporte resistentes, es la compañera imprescindible para comidas al aire libre, terrazas o llevar tu vino preferido a casa de amigos. Personalízala con tu logotipo o marca de bodega a láser para regalos de empresa prácticos y promociones de verano.",
    "specs": [
      "Personalización exclusiva:",
      "Olvídate del vino caliente. ¡Pide tu bolsa conservadora Cata hoy mismo!"
    ],
    "image": "/catalog/bolsa-conservadora-de-frio-para-botella-de-vino-cata_1.jpg",
    "images": [
      "/catalog/bolsa-conservadora-de-frio-para-botella-de-vino-cata_1.jpg",
      "/catalog/bolsa-conservadora-de-frio-para-botella-de-vino-cata_2.jpg",
      "/catalog/bolsa-conservadora-de-frio-para-botella-de-vino-cata_3.jpg",
      "/catalog/bolsa-conservadora-de-frio-para-botella-de-vino-cata_4.jpg",
      "/catalog/bolsa-conservadora-de-frio-para-botella-de-vino-cata_5.jpg",
      "/catalog/bolsa-conservadora-de-frio-para-botella-de-vino-cata_6.jpg"
    ],
    "basePrice": 1.35,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Bolsa Conservadora De Frio Para Botella De Vino “Cata”",
    "titleEn": "Cata Thermal Insulated Wine Bag",
    "nameEn": "Cata Thermal Insulated Wine Bag",
    "categoryEn": "Bags & Coolers",
    "descriptionEn": "Padded thermal cooler bag for single wine bottle with thermal foil lining and zip closure.",
    "extendedDescriptionEn": "Keep fine wine at cellar temperature on the road. The Cata thermal tote features thick insulating foam, reflective foil lining, and a comfortable shoulder strap.",
    "specsEn": [
      "Thermal insulating foam & foil lining",
      "Full zip closure",
      "Fits Burgundy, Bordeaux & Cava bottles",
      "Durable water-resistant exterior"
    ]
  },
  {
    "id": "bolsa-de-vino-navidena-kayla",
    "name": "Bolsa De Vino Navideña Kayla",
    "reference": "CF-002",
    "category": "Bolsas y Enfriadores",
    "description": "Soporte de alta gama para vino y sumillería con acabado optimizado para personalización láser UV.",
    "extendedDescription": "Viste tus botellas con la magia y el calor de la Navidad. 🎄🍷✨ La Bolsa Navideña Kayla aporta ese toque festivo y entrañable a cualquier botella de vino o cava. Con diseño navideño tradicional, tejido cálido y cierre ajustable, convierte un simple vino en un regalo lleno de ilusión para estas fiestas. Personalizamos los adornos y etiquetas a láser con nombres familiares, dedicatorias navideñas o el escudo de tu empresa.",
    "specs": [
      "Personalización exclusiva:",
      "Prepara tus detalles de Navidad con tiempo. ¡Consúltanos pedidos y lotes!"
    ],
    "image": "/catalog/bolsa-de-vino-navidena-kayla_1.jpg",
    "images": [
      "/catalog/bolsa-de-vino-navidena-kayla_1.jpg",
      "/catalog/bolsa-de-vino-navidena-kayla_2.jpg",
      "/catalog/bolsa-de-vino-navidena-kayla_3.jpg",
      "/catalog/bolsa-de-vino-navidena-kayla_4.jpg"
    ],
    "basePrice": 1.25,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Bolsa De Vino Navideña Kayla",
    "titleEn": "Kayla Festive Holiday Wine Bag",
    "nameEn": "Kayla Festive Holiday Wine Bag",
    "categoryEn": "Bags & Coolers",
    "descriptionEn": "Festive holiday gift bag for wine bottles with seasonal motifs, drawstring closure, and gift tag.",
    "extendedDescriptionEn": "Dress holiday bottles with joyful sophistication. The Kayla gift bag features warm festive texture, drawstring ribbon closure, and customizable gift tag.",
    "specsEn": [
      "Festive seasonal textured fabric",
      "Satin drawstring ribbon",
      "Built-in customizable greeting tag",
      "Fits standard 75cl bottles"
    ]
  },
  {
    "id": "bolsa-fieltro-para-vino",
    "name": "Bolsa Fieltro Para Vino",
    "reference": "CF-003",
    "category": "Bolsas y Enfriadores",
    "description": "Soporte de alta gama para vino y sumillería con acabado optimizado para personalización láser UV.",
    "extendedDescription": "La sofisticación del fieltro: calidez, diseño minimalista y máxima protección. 🧶🍷 Nuestra Bolsa de Fieltro para vino destaca por su tacto suave y su estructura densa y protectora. Protege la botella frente a golpes y cambios de temperatura a la vez que ofrece una estética sobria y moderna con asas reforzadas. El fieltro grabado a láser adquiere un relieve oscuro y definido muy elegante, perfecto para bodegas vanguardistas y regalos corporativos.",
    "specs": [
      "Personalización exclusiva:",
      "Eleva la presentación de tus botellas con el estilo nórdico del fieltro. ¡Escríbenos!"
    ],
    "image": "/catalog/bolsa-fieltro-para-vino_1.jpg",
    "images": [
      "/catalog/bolsa-fieltro-para-vino_1.jpg",
      "/catalog/bolsa-fieltro-para-vino_2.jpg",
      "/catalog/bolsa-fieltro-para-vino_3.jpg",
      "/catalog/bolsa-fieltro-para-vino_4.jpg",
      "/catalog/bolsa-fieltro-para-vino_5.jpg"
    ],
    "basePrice": 3.45,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Bolsa Fieltro Para Vino",
    "titleEn": "Nordic Felt Wine Bottle Tote",
    "nameEn": "Nordic Felt Wine Bottle Tote",
    "categoryEn": "Bags & Coolers",
    "descriptionEn": "Eco-felt protective single bottle carrier with die-cut carry handles and reinforced bottom.",
    "extendedDescriptionEn": "Nordic minimalist design. Thick recycled eco-felt provides cushioned shock protection against knocks while insulating the bottle during transport.",
    "specsEn": [
      "Thick recycled eco-felt",
      "Die-cut reinforced handles",
      "Thermal shock insulation",
      "Crisp laser engraved logo contrast"
    ]
  },
  {
    "id": "bolsa-non-woven-botella-mantua",
    "name": "Bolsa Non Woven Botella Mantua",
    "reference": "CF-004",
    "category": "Bolsas y Enfriadores",
    "description": "Soporte de alta gama para vino y sumillería con acabado optimizado para personalización láser UV.",
    "extendedDescription": "Ligereza, resistencia y el empaque más práctico para ferias y bodegas. 🛍️🍷 La Bolsa Mantua para botella de vino está fabricada en tejido Non-Woven de alta resistencia y gramaje óptimo. Sus asas ergonómicas y fuelle reforzado permiten transportar botellas con total seguridad en eventos, ferias del vino o compras en bodega. Ideal para campañas publicitarias de gran tirada. Marcaje de precisión para destacar tu marca al mejor coste.",
    "specs": [
      "Personalización exclusiva:",
      "¿Organizas un evento o feria? Pídenos presupuesto sin compromiso."
    ],
    "image": "/catalog/bolsa-non-woven-botella-mantua_1.jpg",
    "images": [
      "/catalog/bolsa-non-woven-botella-mantua_1.jpg",
      "/catalog/bolsa-non-woven-botella-mantua_2.jpg",
      "/catalog/bolsa-non-woven-botella-mantua_3.jpg",
      "/catalog/bolsa-non-woven-botella-mantua_4.jpg",
      "/catalog/bolsa-non-woven-botella-mantua_5.jpg",
      "/catalog/bolsa-non-woven-botella-mantua_6.jpg"
    ],
    "basePrice": 0.9,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Bolsa Non Woven Botella Mantua",
    "titleEn": "Mantua Non-Woven Bottle Tote",
    "nameEn": "Mantua Non-Woven Bottle Tote",
    "categoryEn": "Bags & Coolers",
    "descriptionEn": "Lightweight 80g/m² non-woven polypropylene tote with heat-sealed seams and long carry handles.",
    "extendedDescriptionEn": "Cost-effective promotional carrier for high-turnover wine retail, trade fairs, and festival giveaways. Available in rich cellar-inspired colors.",
    "specsEn": [
      "80 g/m² Non-woven polypropylene",
      "Heat-sealed reinforced seams",
      "Long shoulder / hand carry handles",
      "High-volume promotional choice"
    ]
  },
  {
    "id": "bolsa-papel-kraft-para-vino-monastrell",
    "name": "Bolsa Papel Kraft Para Vino Monastrell",
    "reference": "CF-005",
    "category": "Bolsas y Enfriadores",
    "description": "Soporte de alta gama para vino y sumillería con acabado optimizado para personalización láser UV.",
    "extendedDescription": "La autenticidad del papel kraft natural: estilo rústico y compromiso ecológico. 📜🌿🍾 La Bolsa Monastrell está elaborada en papel kraft grueso de alta resistencia con asas rizadas a juego. Pensada especialmente para botellas de 75 cl, aporta ese aspecto artesanal y ecológico que tanto valoran los amantes de lo auténtico. Grabable o personalizable para vinotecas, tiendas gourmet y eventos sostenibles que cuidan cada detalle.",
    "specs": [
      "Personalización exclusiva:",
      "Un envoltorio sostenible y con mucha personalidad. ¡Pregúntanos por cantidades!"
    ],
    "image": "/catalog/bolsa-papel-kraft-para-vino-monastrell_1.jpg",
    "images": [
      "/catalog/bolsa-papel-kraft-para-vino-monastrell_1.jpg",
      "/catalog/bolsa-papel-kraft-para-vino-monastrell_2.jpg",
      "/catalog/bolsa-papel-kraft-para-vino-monastrell_3.jpg",
      "/catalog/bolsa-papel-kraft-para-vino-monastrell_4.jpg"
    ],
    "basePrice": 0.9,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Bolsa Papel Kraft Para Vino Monastrell",
    "titleEn": "Monastrell Kraft Paper Wine Bag",
    "nameEn": "Monastrell Kraft Paper Wine Bag",
    "categoryEn": "Bags & Coolers",
    "descriptionEn": "Heavyweight 120g/m² ribbed natural kraft paper wine bag with twisted paper handles and reinforced card base.",
    "extendedDescriptionEn": "Artisanal bakery and winery packaging classic. Made from strong ribbed natural kraft paper with reinforced cardstock base insert for reliable bottle support.",
    "specsEn": [
      "Heavyweight 120 g/m² ribbed kraft",
      "Twisted paper cord handles",
      "Reinforced cardboard bottom base",
      "100% Recyclable & biodegradable"
    ]
  },
  {
    "id": "bolsa-para-vino-chianti",
    "name": "Bolsa Para Vino Chianti",
    "reference": "CF-006",
    "category": "Bolsas y Enfriadores",
    "description": "Soporte de alta gama para vino y sumillería con acabado optimizado para personalización láser UV.",
    "extendedDescription": "La elegancia clásica que toda gran botella merece para ser regalada. 🍇👜 La Bolsa para vino Chianti combina acabados de calidad superior, estructura firme y asas confortables. Diseñada para proteger y ensalzar la presencia de los mejores tintos y blancos de guarda. Añadimos tu sello distintivo grabado a láser para crear una experiencia de unboxing que tu cliente o ser querido recordará.",
    "specs": [
      "Personalización exclusiva:",
      "Haz que tu regalo hable de buen gusto desde el primer vistazo. ¡Haz tu pedido!"
    ],
    "image": "/catalog/bolsa-para-vino-chianti_1.jpg",
    "images": [
      "/catalog/bolsa-para-vino-chianti_1.jpg",
      "/catalog/bolsa-para-vino-chianti_2.jpg",
      "/catalog/bolsa-para-vino-chianti_3.jpg",
      "/catalog/bolsa-para-vino-chianti_4.jpg",
      "/catalog/bolsa-para-vino-chianti_5.jpg"
    ],
    "basePrice": 1.6,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Bolsa Para Vino Chianti",
    "titleEn": "Chianti Cotton Drawstring Bag",
    "nameEn": "Chianti Cotton Drawstring Bag",
    "categoryEn": "Bags & Coolers",
    "descriptionEn": "100% Unbleached natural cotton bottle bag with double drawstring closure for 75cl bottles.",
    "extendedDescriptionEn": "Rustic charm for farm-to-table wineries and organic vineyards. Breathable unbleached natural cotton protects labels from scratches and dust.",
    "specsEn": [
      "100% Unbleached natural cotton",
      "Double braided drawstring cords",
      "Protects wine labels from abrasion",
      "Washable and reusable"
    ]
  },
  {
    "id": "bolsa-vino-organza-trepy",
    "name": "Bolsa Vino Organza Trepy",
    "reference": "CF-007",
    "category": "Bolsas y Enfriadores",
    "description": "Soporte de alta gama para vino y sumillería con acabado optimizado para personalización láser UV.",
    "extendedDescription": "Sutileza, delicadeza y brillo para las celebraciones más especiales. 🎀✨🍾 La Bolsa Trepy está confeccionada en tejido de organza semitransparente con cordón de cierre a juego. Deja entrever la silueta y la etiqueta de la botella aportando un aire festivo, ligero y refinado. El complemento estrella para bodas, comuniones, aniversarios y detalles para invitados.",
    "specs": [
      "Personalización exclusiva:",
      "Viste tus botellas de fiesta. ¡Escríbenos y consulta los colores disponibles!"
    ],
    "image": "/catalog/bolsa-vino-organza-trepy_1.jpg",
    "images": [
      "/catalog/bolsa-vino-organza-trepy_1.jpg",
      "/catalog/bolsa-vino-organza-trepy_2.jpg",
      "/catalog/bolsa-vino-organza-trepy_3.jpg",
      "/catalog/bolsa-vino-organza-trepy_4.jpg"
    ],
    "basePrice": 1.3,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Bolsa Vino Organza Trepy",
    "titleEn": "Trepy Sheer Organza Wine Bag",
    "nameEn": "Trepy Sheer Organza Wine Bag",
    "categoryEn": "Bags & Coolers",
    "descriptionEn": "Delicate translucent organza gift pouch with satin ribbon pull cords for weddings and celebrations.",
    "extendedDescriptionEn": "Ethereal presentation that lets the wine bottle and custom laser engraved glass shine through. Perfect for wedding favors, christenings, and gala dinners.",
    "specsEn": [
      "Translucent shimmering organza",
      "Twin satin pull ribbons",
      "Highlights custom laser bottle engraving",
      "Fits standard wine & champagne"
    ]
  },
  {
    "id": "embalaje-de-tubo-para-vino-berin",
    "name": "Embalaje De Tubo Para Vino Berin",
    "reference": "CF-008",
    "category": "Accesorios de Sumiller",
    "description": "Soporte de alta gama para vino y sumillería con acabado optimizado para personalización láser UV.",
    "extendedDescription": "Protección cilíndrica rígida y presencia monumental para tus botellas más exclusivas. 🏛️🍷 El Embalaje de Tubo Berin está fabricado en cartón rígido de alta densidad con tapa metálica o de madera. Su formato tubular ofrece una protección integral contra impactos y una presentación de reserva gran estatus. La superficie del tubo y la tapa admiten grabado láser de máxima definición, convirtiendo cada botella en una pieza de coleccionista.",
    "specs": [
      "Personalización exclusiva:",
      "Presenta tus botellas de gama alta como se merecen. ¡Pide tu presupuesto personalizado!"
    ],
    "image": "/catalog/embalaje-de-tubo-para-vino-berin_1.jpg",
    "images": [
      "/catalog/embalaje-de-tubo-para-vino-berin_1.jpg",
      "/catalog/embalaje-de-tubo-para-vino-berin_2.jpg",
      "/catalog/embalaje-de-tubo-para-vino-berin_3.jpg",
      "/catalog/embalaje-de-tubo-para-vino-berin_4.jpg"
    ],
    "basePrice": 5.5,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Embalaje De Tubo Para Vino Berin",
    "titleEn": "Berin Rigid Cardboard Wine Tube",
    "nameEn": "Berin Rigid Cardboard Wine Tube",
    "categoryEn": "Sommelier Accessories",
    "descriptionEn": "Rigid cylinder tube packaging with metal tinplate base and lid for premium single bottle presentation.",
    "extendedDescriptionEn": "The gold standard for reserve wines and single malts. Heavy-gauge rigid cardboard cylinder with embossed tin lid and base, offering full 360-degree protection.",
    "specsEn": [
      "Heavy-duty rigid cardboard body",
      "Embossed tinplate base and lid",
      "Superior impact protection",
      "Optimal for prestige cuvées"
    ]
  },
  {
    "id": "estuche-vino-px-con-abridor-sacacorchos",
    "name": "Estuche Vino Px Con Abridor Sacacorchos",
    "reference": "CF-009",
    "category": "Sacacorchos y Abridores",
    "description": "Soporte de alta gama para vino y sumillería con acabado optimizado para personalización láser UV.",
    "extendedDescription": "Botella y descorche unidos en un estuche que lo tiene todo para sorprender. 🎁🍷👌 Este set incluye un abridor sacacorchos \"PULLMAN\" y una botella de vino Pedro Ximenez, con de capacidad 50 cl Personalizamos tanto el exterior del estuche como el propio abridor a láser con nombres, iniciales o logos corporativos.",
    "specs": [
      "Personalización exclusiva:",
      "El regalo directo al éxito. ¡Contáctanos y personalízalo para tu próxima ocasión!"
    ],
    "image": "/catalog/estuche-vino-px-con-abridor-sacacorchos_1.jpg",
    "images": [
      "/catalog/estuche-vino-px-con-abridor-sacacorchos_1.jpg",
      "/catalog/estuche-vino-px-con-abridor-sacacorchos_2.jpg",
      "/catalog/estuche-vino-px-con-abridor-sacacorchos_3.jpg",
      "/catalog/estuche-vino-px-con-abridor-sacacorchos_4.jpg",
      "/catalog/estuche-vino-px-con-abridor-sacacorchos_5.jpg"
    ],
    "basePrice": 48.5,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Estuche Vino Px Con Abridor Sacacorchos",
    "titleEn": "PX Wood Wine Box with Waiter's Opener",
    "nameEn": "PX Wood Wine Box with Waiter's Opener",
    "categoryEn": "Corkscrews & Openers",
    "descriptionEn": "Natural pine wood wine box with sliding lid and built-in groove holding a stainless sommelier corkscrew.",
    "extendedDescriptionEn": "A ready-to-open gift presentation. Natural pine box tailored for one 75cl bottle, featuring a dedicated cut-out in the sliding lid that includes a stainless corkscrew.",
    "specsEn": [
      "Solid natural pine wood",
      "Sliding cover with corkscrew recess",
      "Includes stainless waiter's corkscrew",
      "Deep laser branding contrast"
    ]
  },
  {
    "id": "pack-6-copas-de-cava-ariana",
    "name": "Pack 6 Copas De Cava Ariana",
    "reference": "CF-010",
    "category": "Copas y Cristal",
    "description": "Soporte de alta gama para vino y sumillería con acabado optimizado para personalización láser UV.",
    "extendedDescription": "Brinda por los momentos que importan con el sonido cristalino del mejor cava. 🥂✨ Pack de 6 copas flauta Ariana fabricadas en cristal de alta pureza y transparencia. Su cáliz estilizado preserva el rosario de burbujas y concentra los aromas de cavas, champagnes y espumosos. Grabamos a láser cada una de las copas con iniciales de novios, fechas de aniversario o escudos de familia con un acabado esmerilado permanente.",
    "specs": [
      "Personalización exclusiva:",
      "Que cada brindis sea eterno. ¡Escríbenos para encargar tu pack personalizado!"
    ],
    "image": "/catalog/pack-6-copas-de-cava-ariana_1.jpg",
    "images": [
      "/catalog/pack-6-copas-de-cava-ariana_1.jpg",
      "/catalog/pack-6-copas-de-cava-ariana_2.jpg",
      "/catalog/pack-6-copas-de-cava-ariana_3.jpg"
    ],
    "basePrice": 126.5,
    "unit": "packs",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Pack 6 Copas De Cava Ariana",
    "titleEn": "Pack of 6 Ariana Cava Flutes 21cl",
    "nameEn": "Pack of 6 Ariana Cava Flutes 21cl",
    "categoryEn": "Glassware & Glasses",
    "descriptionEn": "Set of 6 crystalline champagne and cava flutes (210ml) with slender stem and fine laser-cut rim.",
    "extendedDescriptionEn": "Engineered to maintain fine effervescence and mousse. Crafted from ultra-clear crystalline glass with a cold-cut thin rim that enhances toast after toast.",
    "specsEn": [
      "Set of 6 flutes (210 ml each)",
      "Lead-free high-clarity crystalline",
      "Laser micro-engraved winery logos",
      "Dishwasher safe industrial grade"
    ]
  },
  {
    "id": "pack-6-copas-de-coctel-giant-sagra",
    "name": "Pack 6 Copas De Cóctel Giant Sagra",
    "reference": "CF-011",
    "category": "Copas y Cristal",
    "description": "Soporte de alta gama para vino y sumillería con acabado optimizado para personalización láser UV.",
    "extendedDescription": "Copas balón de gran formato para disfrutar de tus combinados y cócteles como un maestro. 🍸🧊🌿 Pack de 6 copas Giant Sagra con generosa capacidad de balón. Ideales para cócteles de autor, gin tonics o vinos aromatizados con hielo y botánicos, con cristal resistente y pie equilibrado. Un regalo sensacional para amantes de la coctelería o locales que grabamos a láser con nombres o marcas.",
    "specs": [
      "Personalización exclusiva:",
      "Lleva la experiencia del cocktail bar a tu casa. ¡Haz tu consulta por DM!"
    ],
    "image": "/catalog/pack-6-copas-de-coctel-giant-sagra_1.jpg",
    "images": [
      "/catalog/pack-6-copas-de-coctel-giant-sagra_1.jpg",
      "/catalog/pack-6-copas-de-coctel-giant-sagra_2.jpg",
      "/catalog/pack-6-copas-de-coctel-giant-sagra_3.jpg"
    ],
    "basePrice": 156.5,
    "unit": "packs",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Pack 6 Copas De Cóctel Giant Sagra",
    "titleEn": "Pack of 6 Giant Sagra Cocktail Glasses",
    "nameEn": "Pack of 6 Giant Sagra Cocktail Glasses",
    "categoryEn": "Glassware & Glasses",
    "descriptionEn": "Set of 6 oversized crystalline balloon cocktail glasses (650ml) for spritz, gin tonic, and sangria.",
    "extendedDescriptionEn": "Generous capacity for signature cocktails and aromatic wine spritzers. The wide bowl allows ice and botanicals to bloom while preserving freshness.",
    "specsEn": [
      "Set of 6 balloon glasses (650 ml)",
      "Wide aromatic bowl silhouette",
      "Reinforced thermal shock stem",
      "Custom frosted laser etching"
    ]
  },
  {
    "id": "set-12-marcadores-de-silicona-para-copas-sazul",
    "name": "Set 12 Marcadores De Silicona Para Copas Sazul",
    "reference": "CF-012",
    "category": "Copas y Cristal",
    "description": "Soporte de alta gama para vino y sumillería con acabado optimizado para personalización láser UV.",
    "extendedDescription": "¡Cada invitado con su copa! Color, diversión y cero confusiones en tus fiestas. 🍷🌈🥂 El Set Sazul incluye 12 marcadores de silicona alimentaria flexible en llamativos colores. Se ajustan con facilidad a la base o tallo de cualquier copa o vaso sin rayar el cristal ni soltarse. Prácticos, lavables, reutilizables y presentados en un set que personalizamos para bodas, catas y eventos multitudinarios.",
    "specs": [
      "Personalización exclusiva:",
      "El accesorio más útil para tus reuniones. ¡Pide el tuyo ahora!"
    ],
    "image": "/catalog/set-12-marcadores-de-silicona-para-copas-sazul_1.jpg",
    "images": [
      "/catalog/set-12-marcadores-de-silicona-para-copas-sazul_1.jpg",
      "/catalog/set-12-marcadores-de-silicona-para-copas-sazul_2.jpg",
      "/catalog/set-12-marcadores-de-silicona-para-copas-sazul_3.jpg",
      "/catalog/set-12-marcadores-de-silicona-para-copas-sazul_4.jpg",
      "/catalog/set-12-marcadores-de-silicona-para-copas-sazul_5.jpg",
      "/catalog/set-12-marcadores-de-silicona-para-copas-sazul_6.jpg"
    ],
    "basePrice": 3.55,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Set 12 Marcadores De Silicona Para Copas Sazul",
    "titleEn": "Sazul Silicone Glass Markers (Set of 12)",
    "nameEn": "Sazul Silicone Glass Markers (Set of 12)",
    "categoryEn": "Glassware & Glasses",
    "descriptionEn": "Set of 12 colorful food-grade silicone suction markers for wine glasses and tumblers.",
    "extendedDescriptionEn": "Fun, practical, and reusable. Suction markers stick firmly to glass bowls or bases without leaving any residue, identifying glasses easily at crowded events.",
    "specsEn": [
      "Set of 12 vibrant distinct colors",
      "100% Food-grade flexible silicone",
      "Suction adherence leaves zero marks",
      "Washable & reusable"
    ]
  },
  {
    "id": "set-de-vino-con-ajedrez-saboya",
    "name": "Set De Vino Con Ajedrez Saboya",
    "reference": "CF-013",
    "category": "Estuches y Sets",
    "description": "Soporte de alta gama para vino y sumillería con acabado optimizado para personalización láser UV.",
    "extendedDescription": "El Set Saboya integra un tablero de ajedrez completo en la tapa exterior del estuche de madera (con todas sus piezas incluidas). En su interior guarda un juego completo de accesorios de sumiller en acero inoxidable. Un regalo intelectual, bello y muy original que grabamos a láser para conmemorar ocasiones especiales. Envíos seguros y preparación cuidada con el máximo detalle.",
    "specs": [
      "¿Vino y ajedrez? La combinación perfecta para tardes de tertulia y estrategia. ♟️🍷🪵",
      "Personalización exclusiva:",
      "Jaque mate al aburrimiento. ¡Escríbenos y encarga el tuyo!"
    ],
    "image": "/catalog/set-de-vino-con-ajedrez-saboya_1.jpg",
    "images": [
      "/catalog/set-de-vino-con-ajedrez-saboya_1.jpg",
      "/catalog/set-de-vino-con-ajedrez-saboya_2.jpg",
      "/catalog/set-de-vino-con-ajedrez-saboya_3.jpg",
      "/catalog/set-de-vino-con-ajedrez-saboya_4.jpg",
      "/catalog/set-de-vino-con-ajedrez-saboya_5.jpg",
      "/catalog/set-de-vino-con-ajedrez-saboya_6.jpg"
    ],
    "basePrice": 32.5,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Set De Vino Con Ajedrez Saboya",
    "titleEn": "Saboya Wine & Chess Luxury Box",
    "nameEn": "Saboya Wine & Chess Luxury Box",
    "categoryEn": "Cases & Gift Sets",
    "descriptionEn": "Solid wooden gift box with printed chess board on lid, complete chess pieces, and 4 sommelier tools inside.",
    "extendedDescriptionEn": "The timeless duel of chess paired with fine wine. The wooden lid acts as a tournament chess board, while the interior houses 32 chess pieces alongside sommelier tools.",
    "specsEn": [
      "Chess board lid with 32 wooden pieces",
      "Includes corkscrew, stopper, collar & pourer",
      "Solid natural wooden chest",
      "A memorable dual-purpose gift"
    ]
  },
  {
    "id": "set-de-vino-premium-salentino",
    "name": "Set De Vino Premium Salentino",
    "reference": "CF-014",
    "category": "Estuches y Sets",
    "description": "Soporte de alta gama para vino y sumillería con acabado optimizado para personalización láser UV.",
    "extendedDescription": "La máxima expresión del lujo vinícola en un estuche de alta gama. 🌟🍷🍾 El Set Salentino es la joya de la corona: accesorios completos de la máxima solidez, terminaciones cuidadas al milímetro y una presencia majestuosa que preside las mejores mesas y vitrinas. El soporte definitivo para el grabado láser de alta resolución: frases conmemorativas, heráldica o marcas exclusivas.",
    "specs": [
      "Personalización exclusiva:",
      "Sorprende a quien lo tiene todo. ¡Contáctanos y diseña tu set Salentino!"
    ],
    "image": "/catalog/set-de-vino-premium-salentino_1.jpg",
    "images": [
      "/catalog/set-de-vino-premium-salentino_1.jpg",
      "/catalog/set-de-vino-premium-salentino_2.jpg",
      "/catalog/set-de-vino-premium-salentino_3.jpg",
      "/catalog/set-de-vino-premium-salentino_4.jpg",
      "/catalog/set-de-vino-premium-salentino_5.jpg",
      "/catalog/set-de-vino-premium-salentino_6.jpg"
    ],
    "basePrice": 50.7,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Set De Vino Premium Salentino",
    "titleEn": "Salentino Premium Sommelier Set",
    "nameEn": "Salentino Premium Sommelier Set",
    "categoryEn": "Cases & Gift Sets",
    "descriptionEn": "Black leatherette presentation box with viewing window, containing luxury rabbit lever opener and foil cutter.",
    "extendedDescriptionEn": "Uncorking elevated to art. The Salentino rabbit lever opener pulls any cork in one effortless fluid motion, paired with a matching foil cutter in an executive gift box.",
    "specsEn": [
      "Executive leatherette box with window",
      "Heavy-gauge rabbit lever corkscrew",
      "Precision foil trimmer included",
      "Supplied with replacement spiral"
    ]
  },
  {
    "id": "set-de-vino-riva",
    "name": "Set De Vino Riva",
    "reference": "CF-015",
    "category": "Estuches y Sets",
    "description": "Soporte de alta gama para vino y sumillería con acabado optimizado para personalización láser UV.",
    "extendedDescription": "Diseño contemporáneo y practicidad para descorchar en cualquier momento. 🍾✨ El Set Riva ofrece un equilibrio perfecto entre compacidad y funcionalidad con accesorios sumiller en acero inoxidable de alto rendimiento y estuche protector resistente. Personalizable a láser con nombres propios o marcas para regalar en eventos o celebraciones familiares.",
    "specs": [
      "Personalización exclusiva:",
      "El kit que todo amante del vino quiere tener a mano. ¡Haz tu pedido ya!"
    ],
    "image": "/catalog/set-de-vino-riva_1.jpg",
    "images": [
      "/catalog/set-de-vino-riva_1.jpg",
      "/catalog/set-de-vino-riva_2.jpg",
      "/catalog/set-de-vino-riva_3.jpg",
      "/catalog/set-de-vino-riva_4.jpg",
      "/catalog/set-de-vino-riva_5.jpg",
      "/catalog/set-de-vino-riva_6.jpg"
    ],
    "basePrice": 10.9,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Set De Vino Riva",
    "titleEn": "Riva Bamboo 3-Piece Wine Set",
    "nameEn": "Riva Bamboo 3-Piece Wine Set",
    "categoryEn": "Cases & Gift Sets",
    "descriptionEn": "Sleek bamboo presentation box with sommelier corkscrew, drip collar, and bamboo bottle stopper.",
    "extendedDescriptionEn": "Pure natural sophistication. Warm golden bamboo casing with magnetic closures, framing polished stainless steel and bamboo sommelier tools.",
    "specsEn": [
      "Natural bamboo case with magnetic catch",
      "Bamboo-accented waiter's corkscrew",
      "Wine stopper & drip-stop collar",
      "Deep laser burning aesthetic"
    ]
  },
  {
    "id": "tapon-corcho-y-madera-con-anillas-identificadoras-para-copas-triana",
    "name": "Tapón Corcho Y Madera Con Anillas Identificadoras Para Copas “Triana”",
    "reference": "CF-016",
    "category": "Copas y Cristal",
    "description": "Soporte de alta gama para vino y sumillería con acabado optimizado para personalización láser UV.",
    "extendedDescription": "El Tapón Triana fusiona un tapón cónico de corcho natural con cabezal de madera pulida que almacena en su cuerpo un juego de anillas identificadoras para copas. Conserva la botella y evita confusiones entre los invitados con máxima elegancia. La cabeza de madera y las anillas se prestan a un grabado láser minucioso con nombres, fechas o escudos. Envíos seguros y preparación cuidada con el máximo detalle.",
    "specs": [
      "¿Tapón hermético y marcadores de copas en una sola pieza artesanal? Pura genialidad. 🍇🪵🥂",
      "Personalización exclusiva:",
      "El detalle más ingenioso y bonito para tus celebraciones. ¡Pídelo ya!"
    ],
    "image": "/catalog/tapon-corcho-y-madera-con-anillas-identificadoras-para-copas-triana_1.jpg",
    "images": [
      "/catalog/tapon-corcho-y-madera-con-anillas-identificadoras-para-copas-triana_1.jpg",
      "/catalog/tapon-corcho-y-madera-con-anillas-identificadoras-para-copas-triana_2.jpg",
      "/catalog/tapon-corcho-y-madera-con-anillas-identificadoras-para-copas-triana_3.jpg",
      "/catalog/tapon-corcho-y-madera-con-anillas-identificadoras-para-copas-triana_4.jpg",
      "/catalog/tapon-corcho-y-madera-con-anillas-identificadoras-para-copas-triana_5.jpg",
      "/catalog/tapon-corcho-y-madera-con-anillas-identificadoras-para-copas-triana_6.jpg"
    ],
    "basePrice": 2.45,
    "unit": "unidades",
    "minQuantity": 1,
    "maxQuantity": 2500,
    "quantityStep": 1,
    "defaultQuantity": 50,
    "active": true,
    "title": "Tapón Corcho Y Madera Con Anillas Identificadoras Para Copas “Triana”",
    "titleEn": "Triana Cork & Wood Stopper with Glass Rings",
    "nameEn": "Triana Cork & Wood Stopper with Glass Rings",
    "categoryEn": "Glassware & Glasses",
    "descriptionEn": "Natural conical cork stopper with wooden head that stores a set of 6 glass identifier rings inside.",
    "extendedDescriptionEn": "An ingenious 2-in-1 craft showpiece. Keeps opened wine bottles sealed with natural cork while storing 6 numbered wooden glass rings on its central post.",
    "specsEn": [
      "Natural conical agglomerated cork",
      "Solid turned wood head & spindle",
      "Includes 6 numbered stem marker rings",
      "Handcrafted laser engraved top"
    ]
  }
];

export const CATALOG_CATEGORIES = [
  "Todos",
  "Accesorios de Sumiller",
  "Aireadores",
  "Bolsas y Enfriadores",
  "Copas y Cristal",
  "Decantadores",
  "Estuches y Sets",
  "Sacacorchos y Abridores"
];

export const CATALOG_CATEGORIES_EN = {
  "Todos": "All",
  "Accesorios de Sumiller": "Sommelier Accessories",
  "Aireadores": "Aerators",
  "Bolsas y Enfriadores": "Bags & Coolers",
  "Copas y Cristal": "Glassware & Glasses",
  "Decantadores": "Decanters",
  "Estuches y Sets": "Cases & Gift Sets",
  "Sacacorchos y Abridores": "Corkscrews & Openers"
};
